// // import React, { useState, useEffect } from "react";
// // import './CostCalculator.css';

// // const MoveCostCalculator = ({ booking }) => {
// //   const MOVE_WEIGHT = {
// //     studio: 1500,
// //     "1br": 2500,
// //     "2br": 4000,
// //     "3br": 6000,
// //     "4br": 8000,
// //   };

// //   const MOVE_TRUCK = {
// //     studio: "16 ft",
// //     "1br": "16–20 ft",
// //     "2br": "20–22 ft",
// //     "3br": "26 ft",
// //     "4br": "26+ ft / 5-ton",
// //   };

// //   const hubs = [
// //     { value: "", label: "Select hub…" },
// //     { value: "43.6532,-79.3832", label: "Toronto Hub" },
// //     { value: "49.2827,-123.1207", label: "Vancouver Hub" },
// //     { value: "51.0447,-114.0719", label: "Calgary Hub" },
// //     { value: "13.0827,80.2707", label: "Chennai Hub" },
// //   ];

// //   const moveSizes = [
// //     { value: "", label: "Select size…" },
// //     { value: "studio", label: "Studio" },
// //     { value: "1br", label: "1 Bedroom" },
// //     { value: "2br", label: "2 Bedroom" },
// //     { value: "3br", label: "3 Bedroom" },
// //     { value: "4br", label: "4 Bedroom" },
// //   ];

// //   const normalizeMoveSize = (moveSize) => {
// //     const moveSizeMap = {
// //       Studio: "studio",
// //       "1 Bedroom": "1br",
// //       "2 Bedroom": "2br",
// //       "3 Bedroom": "3br",
// //       "4 Bedroom": "4br",
// //     };
// //     return moveSizeMap[moveSize] || (typeof moveSize === 'string' ? moveSize.toLowerCase() : '');
// //   };

// //   const parseMoveSize = (input) => {
// //     if (!input || typeof input !== 'string') return { moveSize: "", weight: "" };
// //     const match = input.match(/(.*?)(\d+)\s*lbs$/i);
// //     if (match) {
// //       const rawSize = match[1].trim();
// //       const weight = match[2];
// //       const normalizedSize = normalizeMoveSize(rawSize);
// //       return { moveSize: normalizedSize, weight };
// //     } else {
// //       return { moveSize: normalizeMoveSize(input), weight: "" };
// //     }
// //   };

// //   const getStaircaseFee = (stairs) => {
// //     const numStairs = parseInt(stairs) || 0;
// //     if (numStairs >= 40) return 600;
// //     if (numStairs >= 30) return 450;
// //     if (numStairs >= 20) return 300;
// //     if (numStairs >= 10) return 150;
// //     return 0;
// //   };

// //   const getLongWalkCharges = (yards) => {
// //     const numYards = parseFloat(yards) || 0;
// //     if (numYards >= 150) return 300;
// //     if (numYards >= 100) return 250;
// //     if (numYards >= 50) return 200;
// //     if (numYards >= 40) return 150;
// //     return 0;
// //   };

// //   const [form, setForm] = useState({
// //     startingHub: "",
// //     moveDate: booking?.Move_Date || "",
// //     origin: booking?.FromAddress || booking?.OriginCity || "",
// //     destination: booking?.ToAddress || booking?.DestinationCity || "",
// //     staircaseFee: "",
// //     longWalkCharges: "",
// //     stopHub: "",
// //     billableKm: "",
// //     nonBillableKm: "",
// //     billableTimeHrs: "",
// //     nonBillableTimeHrs: "",
// //     moveSize: "",
// //     estWeightLbs: "",
// //     truckSize: "",
// //     numMen: "2",
// //     loadingTimeHrs: "",
// //     unloadingTimeHrs: "",
// //     driverCost: "",
// //     helpersCost: "",
// //     totalLabourCost: "",
// //     truckCost: "200",
// //     fuelCost: "",
// //     subTotal: "",
// //     leadCost: "0",
// //     opsExpense: "0",
// //     profitPct: "50",
// //     ACVLSplitPct: "50",
// //     vendorsplitPct: "50",
// //   });

// //   const [distanceStatus, setDistanceStatus] = useState(
// //     "Billable = Origin → Destination. Non-billable = Start Hub → Origin + Destination → Stop Hub."
// //   );
// //   const [totalCost, setTotalCost] = useState(0);
// //   const [breakdown, setBreakdown] = useState("");
// //   const [apiKey, setApiKey] = useState("");
// //   const [isDistanceFetched, setIsDistanceFetched] = useState(false);
// //   const [isFetching, setIsFetching] = useState(false);
// //   const [collapsedSections, setCollapsedSections] = useState({
// //     jobDetails: true,
// //     moveDetails: true,
// //     distanceCost: true,
// //     results: false,
// //   });

// //   useEffect(() => {
// //     const fetchApiKey = async () => {
// //       try {
// //         const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/api/get-google-api-key");
// //         const data = await response.json();
// //         setApiKey(data.apiKey || "");
// //       } catch (error) {
// //         console.error("Failed to fetch API key:", error);
// //         setDistanceStatus("Error fetching API key.");
// //       }
// //     };

// //     fetchApiKey();

// //     const { moveSize: normalizedMoveSize, weight } = parseMoveSize(booking?.Move_Size);
// //     const totalStairs = parseInt(booking?.NoOfStaircasesAtOrigin || 0) + parseInt(booking?.NoOfStaircasesAtDestination || 0);
// //     const staircaseFee = getStaircaseFee(totalStairs);
// //     const totalYards = parseFloat(booking?.LongWalkAtOrigin || 0) + parseFloat(booking?.LongWalkAtDestination || 0);
// //     const longWalkCharges = getLongWalkCharges(totalYards);
// //     const updates = {
// //       origin: booking?.FromAddress || booking?.OriginCity || "",
// //       destination: booking?.ToAddress || booking?.DestinationCity || "",
// //       moveSize: normalizedMoveSize,
// //       estWeightLbs: weight || (normalizedMoveSize ? MOVE_WEIGHT[normalizedMoveSize] || "" : ""),
// //       truckSize: normalizedMoveSize ? MOVE_TRUCK[normalizedMoveSize] || "" : "",
// //       staircaseFee: staircaseFee ? staircaseFee.toFixed(2) : "0.00",
// //       longWalkCharges: longWalkCharges ? longWalkCharges.toFixed(2) : "0.00",
// //     };
// //     setForm((prev) => ({ ...prev, ...updates }));
// //     if (normalizedMoveSize || weight) {
// //       autoLoadUnload();
// //       calculate();
// //     }
// //   }, [booking]);

// //   useEffect(() => {
// //     if (
// //       form.billableKm ||
// //       form.nonBillableKm ||
// //       form.estWeightLbs ||
// //       form.numMen ||
// //       form.truckCost ||
// //       form.profitPct ||
// //       form.ACVLSplitPct ||
// //       form.staircaseFee ||
// //       form.longWalkCharges
// //     ) {
// //       calculate();
// //     }
// //   }, [
// //     form.billableKm,
// //     form.nonBillableKm,
// //     form.estWeightLbs,
// //     form.numMen,
// //     form.truckCost,
// //     form.profitPct,
// //     form.ACVLSplitPct,
// //     form.staircaseFee,
// //     form.longWalkCharges,
// //   ]);

// //   const fmtMoney = (v) => {
// //     const num = parseFloat(v);
// //     return isFinite(num) ? (num < 0 ? "-$" : "$") + Math.abs(num).toFixed(2) : "$0.00";
// //   };

// //   const updateForm = (updates) => {
// //     setForm((prev) => {
// //       const newForm = { ...prev, ...updates };
// //       if (updates.ACVLSplitPct !== undefined) {
// //         const acvlSplit = parseFloat(updates.ACVLSplitPct) || 0;
// //         newForm.vendorsplitPct = (100 - acvlSplit).toFixed(1);
// //       }
// //       return newForm;
// //     });
// //   };

// //   const autoLoadUnload = () => {
// //     const w = parseFloat(form.estWeightLbs) || 0;
// //     const men = parseInt(form.numMen) || 1;
// //     const crewFactor = men / 2;
// //     const loadHrs = crewFactor > 0 ? w / (650 * crewFactor) : 0;
// //     const unloadHrs = crewFactor > 0 ? w / (850 * crewFactor) : 0;

// //     console.log('autoLoadUnload:', { w, men, crewFactor, loadHrs, unloadHrs });

// //     updateForm({
// //       loadingTimeHrs: isFinite(loadHrs) ? loadHrs.toFixed(2) : "0.00",
// //       unloadingTimeHrs: isFinite(unloadHrs) ? unloadHrs.toFixed(2) : "0.00",
// //     });
// //   };

// //   const autoLabourCost = () => {
// //     const bt = parseFloat(form.billableTimeHrs) || parseFloat(form.billableKm || 0) / 100 || 0;
// //     const nbt = parseFloat(form.nonBillableTimeHrs) || parseFloat(form.nonBillableKm || 0) / 100 || 0;
// //     const load = parseFloat(form.loadingTimeHrs) || 0;
// //     const unload = parseFloat(form.unloadingTimeHrs) || 0;
// //     const men = parseInt(form.numMen) || 1;

// //     const travel = bt + nbt;
// //     const driverCost = (travel + load + unload) * 20;
// //     const helpers = Math.max(0, men - 1);
// //     const helperPer = (load + unload) * 20 + travel * 10;
// //     const helpersCost = helpers * helperPer;
// //     const totalLabour = driverCost + helpersCost;

// //     console.log('autoLabourCost:', { bt, nbt, load, unload, men, travel, driverCost, helpersCost, totalLabour });

// //     updateForm({
// //       driverCost: isFinite(driverCost) ? driverCost.toFixed(2) : "0.00",
// //       helpersCost: isFinite(helpersCost) ? helpersCost.toFixed(2) : "0.00",
// //       totalLabourCost: isFinite(totalLabour) ? totalLabour.toFixed(2) : "0.00",
// //     });
// //   };

// //   const autoFuelCost = () => {
// //     const billKm = parseFloat(form.billableKm) || 0;
// //     const nonBillKm = parseFloat(form.nonBillableKm) || 0;
// //     const totalKm = billKm + nonBillKm;
// //     const fuel = (totalKm / 3.5) * 1.7;

// //     console.log('autoFuelCost:', { billKm, nonBillKm, totalKm, fuel });

// //     updateForm({ fuelCost: isFinite(fuel) ? fuel.toFixed(2) : "0.00" });
// //   };

// //   const autoFixedCosts = () => {
// //     const labour = parseFloat(form.totalLabourCost) || 0;
// //     const truck = parseFloat(form.truckCost) || 0;
// //     const fuel = parseFloat(form.fuelCost) || 0;
// //     const stairsFee = parseFloat(form.staircaseFee) || 0;
// //     const walkFee = parseFloat(form.longWalkCharges) || 0;

// //     if (!isFinite(labour) || !isFinite(truck) || !isFinite(fuel) || !isFinite(stairsFee) || !isFinite(walkFee)) {
// //       console.warn('autoFixedCosts: Invalid input detected:', {
// //         labour,
// //         truck,
// //         fuel,
// //         stairsFee,
// //         walkFee,
// //         rawInputs: {
// //           totalLabourCost: form.totalLabourCost,
// //           truckCost: form.truckCost,
// //           fuelCost: form.fuelCost,
// //           staircaseFee: form.staircaseFee,
// //           longWalkCharges: form.longWalkCharges,
// //         }
// //       });
// //     }

// //     const sub = labour + truck + fuel + stairsFee + walkFee;

// //     console.log('autoFixedCosts:', {
// //       labour,
// //       truck,
// //       fuel,
// //       stairsFee,
// //       walkFee,
// //       sub,
// //       rawInputs: {
// //         totalLabourCost: form.totalLabourCost,
// //         truckCost: form.truckCost,
// //         fuelCost: form.fuelCost,
// //         staircaseFee: form.staircaseFee,
// //         longWalkCharges: form.longWalkCharges,
// //       }
// //     });

// //     updateForm({
// //       subTotal: isFinite(sub) ? sub.toFixed(2) : "0.00",
// //       leadCost: isFinite(sub) ? (sub * 0.05).toFixed(2) : "0.00",
// //       opsExpense: isFinite(sub) ? (sub * 0.10).toFixed(2) : "0.00",
// //     });
// //   };

// //   const fetchDistances = async () => {
// //     setDistanceStatus('Looking up distances and times…');
// //     setIsFetching(true);
// //     setIsDistanceFetched(false);
// //     try {
// //       const { startingHub, stopHub, origin, destination } = form;
// //       if (!(startingHub && stopHub && origin && destination)) {
// //         setDistanceStatus('Please fill Starting Hub, Stop Hub, Origin, and Destination.');
// //         setIsFetching(false);
// //         return;
// //       }

// //       const response = await fetch('https://salesjet-10097049716.development.catalystappsail.com/api/calculate-distances', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify({ startingHub, stopHub, origin, destination }),
// //       });

// //       if (!response.ok) {
// //         throw new Error('Failed to fetch distances from server.');
// //       }

// //       const data = await response.json();
// //       const billableKm = parseFloat(data.billableKm) || 0;
// //       const nonBillableKm = parseFloat(data.nonBillableKm) || 0;
// //       const billableTimeHrs = parseFloat(data.billableTimeHrs) || billableKm / 100;
// //       const nonBillableTimeHrs = parseFloat(data.nonBillableTimeHrs) || nonBillableKm / 100;

// //       console.log('fetchDistances:', { billableKm, nonBillableKm, billableTimeHrs, nonBillableTimeHrs });

// //       updateForm({
// //         billableKm: isFinite(billableKm) ? billableKm.toFixed(1) : "0.0",
// //         nonBillableKm: isFinite(nonBillableKm) ? nonBillableKm.toFixed(1) : "0.0",
// //         billableTimeHrs: isFinite(billableTimeHrs) ? billableTimeHrs.toFixed(2) : "0.00",
// //         nonBillableTimeHrs: isFinite(nonBillableTimeHrs) ? nonBillableTimeHrs.toFixed(2) : "0.00",
// //       });
// //       autoLoadUnload();
// //       calculate();
// //       setIsDistanceFetched(true);
// //       setDistanceStatus(
// //         `Updated ✓ Billable: ${isFinite(billableKm) ? billableKm.toFixed(1) : "0.0"} km (${isFinite(billableTimeHrs) ? billableTimeHrs.toFixed(2) : "0.00"} hrs) • Non-billable: ${isFinite(nonBillableKm) ? nonBillableKm.toFixed(1) : "0.0"} km (${isFinite(nonBillableTimeHrs) ? nonBillableTimeHrs.toFixed(2) : "0.00"} hrs)`
// //       );
// //     } catch (err) {
// //       console.error('Fetch distances error:', err);
// //       setDistanceStatus('Distance and time lookup failed. Check locations or try again.');
// //       setIsDistanceFetched(false);
// //     } finally {
// //       setIsFetching(false);
// //     }
// //   };

// //   const calculate = async () => {
// //     // Ensure all auto-calculations complete before proceeding
// //     await Promise.resolve().then(() => {
// //       autoLoadUnload();
// //       autoLabourCost();
// //       autoFuelCost();
// //       autoFixedCosts();
// //     });

// //     const subTotal = parseFloat(form.subTotal) || 0;
// //     const lead = parseFloat(form.leadCost) || 0;
// //     const ops = parseFloat(form.opsExpense) || 0;
// //     const profitPct = (parseFloat(form.profitPct) || 0) / 100;
// //     const acvlSplitPct = (parseFloat(form.ACVLSplitPct) || 0) / 100;
// //     const vendorSplitPct = (parseFloat(form.vendorsplitPct) || 0) / 100;
// //     const profitBase = subTotal + lead + ops;
// //     const profit = profitBase * profitPct;
// //     const total = profitBase + profit;
// //     const acvlProfit = profit * acvlSplitPct;
// //     const vendorProfit = profit * vendorSplitPct;

// //     console.log('calculate:', {
// //       subTotal,
// //       lead,
// //       ops,
// //       profitPct,
// //       profitBase,
// //       profit,
// //       total,
// //       acvlProfit,
// //       vendorProfit,
// //       formState: {
// //         totalLabourCost: form.totalLabourCost,
// //         truckCost: form.truckCost,
// //         fuelCost: form.fuelCost,
// //         staircaseFee: form.staircaseFee,
// //         longWalkCharges: form.longWalkCharges,
// //       }
// //     });

// //     setTotalCost(isFinite(total) ? total : 0);
// //     setBreakdown(
// //       `Sub-Total: ${fmtMoney(subTotal)} • Labour: ${fmtMoney(
// //         parseFloat(form.totalLabourCost) || 0
// //       )} (Driver ${fmtMoney(parseFloat(form.driverCost) || 0)} + Helpers ${fmtMoney(
// //         parseFloat(form.helpersCost) || 0
// //       )}) • Truck: ${fmtMoney(
// //         parseFloat(form.truckCost) || 0
// //       )} • Fuel: ${fmtMoney(parseFloat(form.fuelCost) || 0)} • Stairs: ${fmtMoney(
// //         parseFloat(form.staircaseFee) || 0
// //       )} • Long Walk: ${fmtMoney(parseFloat(form.longWalkCharges) || 0)}
// // Lead (5%): ${fmtMoney(lead)} • Ops (10%): ${fmtMoney(ops)} • Profit (${
// //         form.profitPct || 0
// //       }%): ${fmtMoney(profit)}
// // ACVL Profit (${form.ACVLSplitPct || 0}%): ${fmtMoney(acvlProfit)} • Vendor Profit (${form.vendorsplitPct || 0}%): ${fmtMoney(vendorProfit)}
// // Travel: Billable ${form.billableKm || 0} km → ${form.billableTimeHrs || 0} hrs; Non-billable ${
// //         form.nonBillableKm || 0
// //       } km → ${form.nonBillableTimeHrs || 0} hrs
// // Loading ${form.loadingTimeHrs || 0} hrs • Unloading ${form.unloadingTimeHrs || 0} hrs
// // Crew: ${form.numMen || 0} men • Move size: ${
// //         form.moveSize || "-"
// //       } • Est. Weight: ${form.estWeightLbs || 0} lbs • Truck: ${form.truckSize || "-"}`
// //     );
// //   };

// //   const reset = () => {
// //     setForm({
// //       startingHub: "",
// //       moveDate: booking?.Move_Date || "",
// //       origin: booking?.FromAddress || booking?.OriginCity || "",
// //       destination: booking?.ToAddress || booking?.DestinationCity || "",
// //       stopHub: "",
// //       billableKm: "",
// //       nonBillableKm: "",
// //       billableTimeHrs: "",
// //       nonBillableTimeHrs: "",
// //       moveSize: "",
// //       estWeightLbs: "",
// //       truckSize: "",
// //       numMen: "2",
// //       loadingTimeHrs: "",
// //       unloadingTimeHrs: "",
// //       driverCost: "",
// //       helpersCost: "",
// //       totalLabourCost: "",
// //       truckCost: "200",
// //       fuelCost: "",
// //       subTotal: "",
// //       leadCost: "0",
// //       opsExpense: "0",
// //       profitPct: "50",
// //       ACVLSplitPct: "50",
// //       vendorsplitPct: "50",
// //       staircaseFee: "",
// //       longWalkCharges: "",
// //     });
// //     setDistanceStatus("Billable = Origin → Destination. Non-billable = Start Hub → Origin + Destination → Stop Hub.");
// //     setTotalCost(0);
// //     setBreakdown("");
// //     setIsDistanceFetched(false);
// //     setIsFetching(false);
// //     setCollapsedSections({
// //       jobDetails: true,
// //       moveDetails: true,
// //       distanceCost: true,
// //       results: false,
// //     });
// //   };

// //   const toggleSection = (section) => {
// //     setCollapsedSections((prev) => ({
// //       ...prev,
// //       [section]: !prev[section],
// //     }));
// //   };

// //   const SelectField = ({ id, label, options, hint, onChange }) => (
// //     <div>
// //       <label htmlFor={id}>{label}</label>
// //       <select
// //         id={id}
// //         value={form[id] || ""}
// //         onChange={onChange || ((e) => {
// //           updateForm({ [id]: e.target.value });
// //           if (id === "startingHub" || id === "stopHub") {
// //             fetchDistances();
// //           }
// //         })}
// //       >
// //         {options.map((opt) => (
// //           <option key={opt.value} value={opt.value}>{opt.label}</option>
// //         ))}
// //       </select>
// //       {hint && <div className="cost_hint">{hint}</div>}
// //     </div>
// //   );

// //   const ComboField = ({ id, label, options, hint }) => (
// //     <div>
// //       <label htmlFor={id}>{label}</label>
// //       <input
// //         id={id}
// //         type="text"
// //         list={`${id}-datalist`}
// //         value={form[id] || ""}
// //         onChange={(e) => {
// //           updateForm({ [id]: e.target.value });
// //           if (id === "startingHub" || id === "stopHub") {
// //             fetchDistances();
// //           }
// //         }}
// //         placeholder="Type location or select hub..."
// //       />
// //       <datalist id={`${id}-datalist`}>
// //         {options.map((opt) => (
// //           <option key={opt.value} value={opt.value}>
// //             {opt.label}
// //           </option>
// //         ))}
// //       </datalist>
// //       {hint && <div className="cost_hint">{hint}</div>}
// //     </div>
// //   );

// //   return (
// //     <div className="cost_wrap">
// //       <main className="cost_wrap">
// //         <section className="cost_card">
// //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Job Details</h2>
// //             <div style={{ display: "flex", alignItems: "center" }}>
// //               <span className="cost_pill">All distances in KM • Times from Google Maps</span>
// //               <button
// //                 onClick={() => toggleSection("jobDetails")}
// //                 style={{
// //                   marginLeft: "10px",
// //                   fontSize: "1.2rem",
// //                   cursor: "pointer",
// //                   color: "#333",
// //                   border: "none",
// //                   background: "none",
// //                 }}
// //               >
// //                 {collapsedSections.jobDetails ? "+" : "−"}
// //               </button>
// //             </div>
// //           </div>
// //           <div className="cost_bar"></div>
// //           {!collapsedSections.jobDetails && (
// //             <div className="cost_grid cost_cols-3">
// //               <div>
// //                 <label htmlFor="origin">Origin (City, Province)</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="origin"
// //                     type="text"
// //                     placeholder="City, ST, Country or lat,lon"
// //                     value={form.origin || ""}
// //                     onChange={(e) => updateForm({ origin: e.target.value })}
// //                     readOnly
// //                   />
// //                 </div>
// //               </div>
// //               <div>
// //                 <label htmlFor="destination">Destination (City, Province)</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="destination"
// //                     type="text"
// //                     placeholder="City, ST, Country or lat,lon"
// //                     value={form.destination || ""}
// //                     onChange={(e) => updateForm({ destination: e.target.value })}
// //                     readOnly
// //                   />
// //                 </div>
// //               </div>
// //               <div>
// //                 <label htmlFor="moveDate">Move Date</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="moveDate"
// //                     type="text"
// //                     placeholder="YYYY-MM-DD"
// //                     value={form.moveDate || ""}
// //                     onChange={(e) => updateForm({ moveDate: e.target.value })}
// //                     readOnly
// //                   />
// //                 </div>
// //               </div>
// //               <div>
// //                 <label htmlFor="moveSize">Move Size (Bedrooms)</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="moveSize"
// //                     type="text"
// //                     placeholder="Select size…"
// //                     value={moveSizes.find(opt => opt.value === form.moveSize)?.label || form.moveSize || ""}
// //                     readOnly
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           )}
// //         </section>

// //         <section className="cost_card">
// //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Move Details & Profit Range</h2>
// //             <button
// //               onClick={() => toggleSection("moveDetails")}
// //               style={{
// //                 fontSize: "1.2rem",
// //                 cursor: "pointer",
// //                 color: "#333",
// //                 border: "none",
// //                 background: "none",
// //               }}
// //             >
// //               {collapsedSections.moveDetails ? "+" : "−"}
// //             </button>
// //           </div>
// //           <div className="cost_bar"></div>
// //           {!collapsedSections.moveDetails && (
// //             <>
// //               <div className="cost_grid cost_cols-3">
// //                 <ComboField
// //                   id="startingHub"
// //                   label="Starting Location (Hub)"
// //                   options={hubs}
// //                 />
// //                 <ComboField
// //                   id="stopHub"
// //                   label="Stop Location (Hub)"
// //                   options={hubs}
// //                 />
// //               </div>
// //               <div className="cost_btns" style={{ marginTop: "8px", position: "relative" }}>
// //                 <button
// //                   type="button"
// //                   onClick={fetchDistances}
// //                   className={isDistanceFetched ? "cost_fetched" : isFetching ? "cost_fetching" : ""}
// //                 >
// //                   Fetch distances and times (Google Maps)
// //                   {isFetching && (
// //                     <span className="spinner" style={{ marginLeft: "8px" }}>↻</span>
// //                   )}
// //                 </button>
// //               </div>
// //               <div className="cost_grid cost_cols-3" style={{ marginTop: "10px" }}>
// //                 <div>
// //                   <label htmlFor="estWeightLbs">Estimated Weight</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="estWeightLbs"
// //                       type="number"
// //                       min="0"
// //                       step="1"
// //                       placeholder="0"
// //                       value={form.estWeightLbs || ""}
// //                       onChange={(e) => {
// //                         updateForm({ estWeightLbs: e.target.value });
// //                         autoLoadUnload();
// //                         calculate();
// //                       }}
// //                     />
// //                     <span>lbs</span>
// //                   </div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="truckSize">Truck Size</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="truckSize"
// //                       type="text"
// //                       placeholder="e.g., 16 ft / 20 ft / 26 ft"
// //                       value={form.truckSize || ""}
// //                       onChange={(e) => updateForm({ truckSize: e.target.value })}
// //                     />
// //                   </div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="numMen">Number of Men</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="numMen"
// //                       type="number"
// //                       min="1"
// //                       step="1"
// //                       placeholder="2"
// //                       value={form.numMen || ""}
// //                       onChange={(e) => {
// //                         updateForm({ numMen: e.target.value });
// //                         autoLoadUnload();
// //                         calculate();
// //                       }}
// //                     />
// //                   </div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="truckCost">Truck Cost</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="truckCost"
// //                       type="number"
// //                       min="0"
// //                       step="0.01"
// //                       placeholder="200"
// //                       value={form.truckCost || ""}
// //                       onChange={(e) => {
// //                         updateForm({ truckCost: e.target.value });
// //                         calculate();
// //                       }}
// //                     />
// //                     <span>$</span>
// //                   </div>
// //                   <div className="cost_hint">Enter truck rental or usage cost manually.</div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="profitPct">Profit Percentage</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="profitPct"
// //                       type="number"
// //                       min="0"
// //                       step="0.1"
// //                       placeholder="50"
// //                       value={form.profitPct || ""}
// //                       onChange={(e) => {
// //                         updateForm({ profitPct: e.target.value });
// //                         calculate();
// //                       }}
// //                     />
// //                     <span>%</span>
// //                   </div>
// //                   <div className="cost_hint">Applied to (Sub-Total + Lead + Ops)</div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="ACVLSplitPct">ACVL Profit Split</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="ACVLSplitPct"
// //                       type="number"
// //                       min="0"
// //                       max="100"
// //                       step="0.1"
// //                       placeholder="50"
// //                       value={form.ACVLSplitPct || ""}
// //                       onChange={(e) => {
// //                         updateForm({ ACVLSplitPct: e.target.value });
// //                         calculate();
// //                       }}
// //                     />
// //                     <span>%</span>
// //                   </div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="vendorsplitPct">Vendor Profit Split</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="vendorsplitPct"
// //                       type="number"
// //                       min="0"
// //                       max="100"
// //                       step="0.1"
// //                       placeholder="50"
// //                       value={form.vendorsplitPct || ""}
// //                       readOnly
// //                     />
// //                     <span>%</span>
// //                   </div>
// //                 </div>
// //               </div>
// //             </>
// //           )}
// //         </section>

// //         <section className="cost_card">
// //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Distance, Cost & Time Calculations</h2>
// //             <button
// //               onClick={() => toggleSection("distanceCost")}
// //               style={{
// //                 fontSize: "1.2rem",
// //                 cursor: "pointer",
// //                 border: "none",
// //                 color: "#333",
// //                 background: "none",
// //               }}
// //             >
// //               {collapsedSections.distanceCost ? "+" : "−"}
// //             </button>
// //           </div>
// //           <div className="cost_bar"></div>
// //           {!collapsedSections.distanceCost && (
// //             <div className="cost_grid cost_cols-2">
// //               <div>
// //                 <label htmlFor="billableKm">Billable Distance</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="billableKm"
// //                     type="number"
// //                     min="0"
// //                     step="0.1"
// //                     placeholder="0"
// //                     value={form.billableKm || ""}
// //                     onChange={(e) => {
// //                       updateForm({ billableKm: e.target.value });
// //                       calculate();
// //                     }}
// //                   />
// //                   <span>km</span>
// //                 </div>
// //                 <div className="cost_hint">Origin → Destination</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="nonBillableKm">Non-Billable Distance</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="nonBillableKm"
// //                     type="number"
// //                     min="0"
// //                     step="0.1"
// //                     placeholder="0"
// //                     value={form.nonBillableKm || ""}
// //                     onChange={(e) => {
// //                       updateForm({ nonBillableKm: e.target.value });
// //                       calculate();
// //                     }}
// //                   />
// //                   <span>km</span>
// //                 </div>
// //                 <div className="cost_hint">Start Hub → Origin + Destination → Stop Hub</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="billableTimeHrs">Billable Travel Time</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="billableTimeHrs"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.billableTimeHrs || ""}
// //                     readOnly
// //                   />
// //                   <span>hrs</span>
// //                 </div>
// //                 <div className="cost_hint">Fetched from Google Maps or estimated as Billable Km / 100</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="nonBillableTimeHrs">Non-Billable Travel Time</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="nonBillableTimeHrs"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.nonBillableTimeHrs || ""}
// //                     readOnly
// //                   />
// //                   <span>hrs</span>
// //                 </div>
// //                 <div className="cost_hint">Fetched from Google Maps or estimated as Non-Billable Km / 100</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="loadingTimeHrs">Loading Time</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="loadingTimeHrs"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.loadingTimeHrs || ""}
// //                     readOnly
// //                   />
// //                   <span>hrs</span>
// //                 </div>
// //                 <div className="cost_hint">Capacity: 650 lbs/hour by 2 men (scaled by crew size).</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="unloadingTimeHrs">Unloading Time</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="unloadingTimeHrs"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.unloadingTimeHrs || ""}
// //                     readOnly
// //                   />
// //                   <span>hrs</span>
// //                 </div>
// //                 <div className="cost_hint">Capacity: 850 lbs/hour by 2 men (scaled by crew size).</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="driverCost">Driver Cost</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="driverCost"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.driverCost || ""}
// //                     readOnly
// //                   />
// //                   <span>$</span>
// //                 </div>
// //                 <div className="cost_hint">(Billable + Non-billable + Loading + Unloading) × $20</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="helpersCost">Helpers Cost</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="helpersCost"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.helpersCost || ""}
// //                     readOnly
// //                   />
// //                   <span>$</span>
// //                 </div>
// //                 <div className="cost_hint">Per helper: (Loading + Unloading) × $20 + (Travel × $10) × helpers (men − 1)</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="totalLabourCost">Total Labour Cost</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="totalLabourCost"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.totalLabourCost || ""}
// //                     readOnly
// //                   />
// //                   <span>$</span>
// //                 </div>
// //               </div>
// //               <div>
// //                 <label htmlFor="fuelCost">Fuel Cost (auto)</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="fuelCost"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.fuelCost || ""}
// //                     readOnly
// //                   />
// //                   <span>$</span>
// //                 </div>
// //                 <div className="cost_hint">Fuel = ((Billable Distance + Non-billable Distance) ÷ 3.5) × 1.7</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="staircaseFee">Staircase Fee</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="staircaseFee"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.staircaseFee || ""}
// //                     readOnly
// //                   />
// //                   <span>$</span>
// //                 </div>
// //                 <div className="cost_hint">Staircase Fee</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="longWalkCharges">Long Walk Charges</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="longWalkCharges"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.longWalkCharges || ""}
// //                     readOnly
// //                   />
// //                   <span>$</span>
// //                 </div>
// //                 <div className="cost_hint">Long Walk Charges</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="subTotal">Sub-Total</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="subTotal"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.subTotal || ""}
// //                     readOnly
// //                   />
// //                   <span>$</span>
// //                 </div>
// //                 <div className="cost_hint">Sub-Total = Labour + Truck + Fuel + Stairs + Long Walk</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="leadCost">Lead Cost (auto)</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="leadCost"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.leadCost || ""}
// //                     readOnly
// //                   />
// //                   <span>$</span>
// //                 </div>
// //                 <div className="cost_hint">Lead = Sub-Total × 0.05</div>
// //               </div>
// //               <div>
// //                 <label htmlFor="opsExpense">Ops Expense (Chennai) (auto)</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="opsExpense"
// //                     type="number"
// //                     min="0"
// //                     step="0.01"
// //                     placeholder="0"
// //                     value={form.opsExpense || ""}
// //                     readOnly
// //                   />
// //                   <span>$</span>
// //                 </div>
// //                 <div className="cost_hint">Ops = Sub-Total × 0.10</div>
// //               </div>
// //             </div>
// //           )}
// //         </section>

// //         <section className="cost_card">
// //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Results</h2>
// //           </div>
// //           <div className="cost_bar"></div>
// //           {!collapsedSections.results && (
// //             <>
// //               <div className="cost_btns">
// //                 <button onClick={reset}>Re-calculate</button>
// //               </div>
// //               <div className="cost_grid cost_cols-2">
// //                 <div className="cost_out">
// //                   <div className="cost_hint">Estimated Total</div>
// //                   <div className="cost_tot" id="totalCostDisplay">{fmtMoney(totalCost)}</div>
// //                   <div className="cost_note">Live formulas based on your rules.</div>
// //                 </div>
// //                 <div className="cost_out">
// //                   <div className="cost_hint">Breakdown</div>
// //                   <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>{breakdown}</pre>
// //                 </div>
// //               </div>
// //             </>
// //           )}
// //         </section>
// //       </main>
// //     </div>
// //   );
// // };

// // export default MoveCostCalculator;

// import React, { useState, useEffect } from "react";
// import './CostCalculator.css';

// const MoveCostCalculator = ({ booking }) => {
//   const MOVE_WEIGHT = {
//     studio: 1500,
//     "1br": 2500,
//     "2br": 4000,
//     "3br": 6000,
//     "4br": 8000,
//   };

//   const MOVE_TRUCK = {
//     studio: "16 ft",
//     "1br": "16–20 ft",
//     "2br": "20–22 ft",
//     "3br": "26 ft",
//     "4br": "26+ ft / 5-ton",
//   };

//   const hubs = [
//     { value: "", label: "Select hub…" },
//     { value: "43.6532,-79.3832", label: "Toronto Hub" },
//     { value: "49.2827,-123.1207", label: "Vancouver Hub" },
//     { value: "51.0447,-114.0719", label: "Calgary Hub" },
//   ];

//   const moveSizes = [
//     { value: "", label: "Select size…" },
//     { value: "studio", label: "Studio" },
//     { value: "1br", label: "1 Bedroom" },
//     { value: "2br", label: "2 Bedroom" },
//     { value: "3br", label: "3 Bedroom" },
//     { value: "4br", label: "4 Bedroom" },
//   ];

//   const normalizeMoveSize = (moveSize) => {
//     const moveSizeMap = {
//       Studio: "studio",
//       "1 Bedroom": "1br",
//       "2 Bedroom": "2br",
//       "3 Bedroom": "3br",
//       "4 Bedroom": "4br",
//     };
//     return moveSizeMap[moveSize] || (typeof moveSize === 'string' ? moveSize.toLowerCase() : '');
//   };

//   const parseMoveSize = (input) => {
//     if (!input || typeof input !== 'string') return { moveSize: "", weight: "" };
//     const match = input.match(/(.*?)(\d+)\s*lbs$/i);
//     if (match) {
//       const rawSize = match[1].trim();
//       const weight = match[2];
//       const normalizedSize = normalizeMoveSize(rawSize);
//       return { moveSize: normalizedSize, weight };
//     } else {
//       return { moveSize: normalizeMoveSize(input), weight: "" };
//     }
//   };

//   const getStaircaseFee = (stairs) => {
//     const numStairs = parseInt(stairs) || 0;
//     if (numStairs >= 40) return 600;
//     if (numStairs >= 30) return 450;
//     if (numStairs >= 20) return 300;
//     if (numStairs >= 10) return 150;
//     return 0;
//   };

//   const getLongWalkCharges = (yards) => {
//     const numYards = parseFloat(yards) || 0;
//     if (numYards >= 150) return 300;
//     if (numYards >= 100) return 250;
//     if (numYards >= 50) return 200;
//     if (numYards >= 40) return 150;
//     return 0;
//   };

//   const [form, setForm] = useState({
//     startingHub: "",
//     moveDate: booking?.Move_Date || "",
//     origin: booking?.FromAddress || booking?.OriginCity || "",
//     destination: booking?.ToAddress || booking?.DestinationCity || "",
//     staircaseFee: "",
//     longWalkCharges: "",
//     stopHub: "",
//     billableKm: "",
//     nonBillableKm: "",
//     billableTimeHrs: "",
//     nonBillableTimeHrs: "",
//     moveSize: "",
//     estWeightLbs: "",
//     truckSize: "",
//     numMen: "2",
//     loadingTimeHrs: "",
//     unloadingTimeHrs: "",
//     driverCost: "",
//     helpersCost: "",
//     totalLabourCost: "",
//     truckCost: "200",
//     fuelCost: "",
//     subTotal: "",
//     leadCost: "0",
//     opsExpense: "0",
//     profitPct: "50",
//     ACVLSplitPct: "50",
//     vendorsplitPct: "50",
//   });

//   const [distanceStatus, setDistanceStatus] = useState(
//     "Billable = Origin → Destination. Non-billable = Start Hub → Origin + Destination → Stop Hub."
//   );
//   const [totalCost, setTotalCost] = useState(0);
//   const [breakdown, setBreakdown] = useState("");
//   const [apiKey, setApiKey] = useState("");
//   const [isDistanceFetched, setIsDistanceFetched] = useState(false);
//   const [isFetching, setIsFetching] = useState(false);
//   const [collapsedSections, setCollapsedSections] = useState({
//     jobDetails: true,
//     moveDetails: true,
//     distanceCost: true,
//     results: false,
//   });

//   useEffect(() => {
//     const fetchApiKey = async () => {
//       try {
//         const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/api/get-google-api-key");
//         const data = await response.json();
//         setApiKey(data.apiKey || "");
//       } catch (error) {
//         console.error("Failed to fetch API key:", error);
//         setDistanceStatus("Error fetching API key.");
//       }
//     };

//     fetchApiKey();

//     const { moveSize: normalizedMoveSize, weight } = parseMoveSize(booking?.Move_Size);
//     const totalStairs = parseInt(booking?.NoOfStaircasesAtOrigin || 0) + parseInt(booking?.NoOfStaircasesAtDestination || 0);
//     const staircaseFee = getStaircaseFee(totalStairs);
//     const totalYards = parseFloat(booking?.LongWalkAtOrigin || 0) + parseFloat(booking?.LongWalkAtDestination || 0);
//     const longWalkCharges = getLongWalkCharges(totalYards);
//     const updates = {
//       origin: booking?.FromAddress || booking?.OriginCity || "",
//       destination: booking?.ToAddress || booking?.DestinationCity || "",
//       moveSize: normalizedMoveSize,
//       estWeightLbs: weight || (normalizedMoveSize ? MOVE_WEIGHT[normalizedMoveSize] || "" : ""),
//       truckSize: normalizedMoveSize ? MOVE_TRUCK[normalizedMoveSize] || "" : "",
//       staircaseFee: staircaseFee ? staircaseFee.toFixed(2) : "0.00",
//       longWalkCharges: longWalkCharges ? longWalkCharges.toFixed(2) : "0.00",
//     };
//     setForm((prev) => ({ ...prev, ...updates }));
//     if (normalizedMoveSize || weight) {
//       autoLoadUnload();
//       calculate();
//     }
//   }, [booking]);

//   useEffect(() => {
//     if (
//       form.billableKm ||
//       form.nonBillableKm ||
//       form.estWeightLbs ||
//       form.numMen ||
//       form.truckCost ||
//       form.profitPct ||
//       form.ACVLSplitPct ||
//       form.staircaseFee ||
//       form.longWalkCharges
//     ) {
//       calculate();
//     }
//   }, [
//     form.billableKm,
//     form.nonBillableKm,
//     form.estWeightLbs,
//     form.numMen,
//     form.truckCost,
//     form.profitPct,
//     form.ACVLSplitPct,
//     form.staircaseFee,
//     form.longWalkCharges,
//   ]);

//   const fmtMoney = (v) => {
//     const num = parseFloat(v);
//     return isFinite(num) ? (num < 0 ? "-$" : "$") + Math.abs(num).toFixed(2) : "$0.00";
//   };

//   const updateForm = (updates) => {
//     setForm((prev) => {
//       const newForm = { ...prev, ...updates };
//       if (updates.ACVLSplitPct !== undefined) {
//         const acvlSplit = parseFloat(updates.ACVLSplitPct) || 0;
//         newForm.vendorsplitPct = (100 - acvlSplit).toFixed(1);
//       }
//       return newForm;
//     });
//   };

//   const autoLoadUnload = () => {
//     const w = parseFloat(form.estWeightLbs) || 0;
//     const men = parseInt(form.numMen) || 1;
//     const crewFactor = men / 2;
//     const loadHrs = crewFactor > 0 ? w / (650 * crewFactor) : 0;
//     const unloadHrs = crewFactor > 0 ? w / (850 * crewFactor) : 0;

//     console.log('autoLoadUnload:', { w, men, crewFactor, loadHrs, unloadHrs });

//     updateForm({
//       loadingTimeHrs: isFinite(loadHrs) ? loadHrs.toFixed(2) : "0.00",
//       unloadingTimeHrs: isFinite(unloadHrs) ? unloadHrs.toFixed(2) : "0.00",
//     });
//   };

// //   const autoLabourCost = () => {
// //     const bt = parseFloat(form.billableTimeHrs) || parseFloat(form.billableKm || 0) / 100 || 0;
// //     const nbt = parseFloat(form.nonBillableTimeHrs) || parseFloat(form.nonBillableKm || 0) / 100 || 0;
// //     const load = parseFloat(form.loadingTimeHrs) || 0;
// //     const unload = parseFloat(form.unloadingTimeHrs) || 0;
// //     const men = parseInt(form.numMen) || 1;

// //     const travel = bt + nbt;
// //     const driverCost = (travel + load + unload) * 20;
// //     const helpers = Math.max(0, men - 1);
// //     const helperPer = (load + unload) * 20 + travel * 10;
// //     const helpersCost = helpers * helperPer;
// //     const totalLabour = driverCost + helpersCost;

// //     console.log('autoLabourCost:', { bt, nbt, load, unload, men, travel, driverCost, helpersCost, totalLabour });

// //     updateForm({
// //       driverCost: isFinite(driverCost) ? driverCost.toFixed(2) : "0.00",
// //       helpersCost: isFinite(helpersCost) ? helpersCost.toFixed(2) : "0.00",
// //       totalLabourCost: isFinite(totalLabour) ? totalLabour.toFixed(2) : "0.00",
// //     });
// //   };

// //   const autoFuelCost = () => {
// //     const billKm = parseFloat(form.billableKm) || 0;
// //     const nonBillKm = parseFloat(form.nonBillableKm) || 0;
// //     const totalKm = billKm + nonBillKm;
// //     const fuel = (totalKm / 3.5) * 1.7;

// //     console.log('autoFuelCost:', { billKm, nonBillKm, totalKm, fuel });

// //     updateForm({ fuelCost: isFinite(fuel) ? fuel.toFixed(2) : "0.00" });
// //     console.log('Updated fuelCost in form:', form.fuelCost);
// //   };
// // //   const autoFixedCosts = () => {
// // //     const labour = parseFloat(form.totalLabourCost) || 0;
// // //     const truck = parseFloat(form.truckCost) || 0;
// // //     const fuel = parseFloat(form.fuelCost) || 0;
// // //     const stairsFee = parseFloat(form.staircaseFee) || 0;
// // //     const walkFee = parseFloat(form.longWalkCharges) || 0;
// // //     const sub = labour + truck + fuel + stairsFee + walkFee;

// // //     console.log('autoFixedCosts:', { labour, truck, fuel, stairsFee, walkFee, sub });

// // //     updateForm({
// // //       subTotal: isFinite(sub) ? sub.toFixed(2) : "0.00",
// // //       leadCost: isFinite(sub) ? (sub * 0.05).toFixed(2) : "0.00",
// // //       opsExpense: isFinite(sub) ? (sub * 0.10).toFixed(2) : "0.00",
// // //     });
// // //   };

// // //   const calculate = () => {
// // //     autoLoadUnload();
// // //     autoLabourCost();
// // //     autoFuelCost();
// // //     autoFixedCosts();

// // //     const subTotal = parseFloat(form.subTotal) || 0;
// // //     const lead = parseFloat(form.leadCost) || 0;
// // //     const ops = parseFloat(form.opsExpense) || 0;
// // //     const profitPct = (parseFloat(form.profitPct) || 0) / 100;
// // //     const acvlSplitPct = (parseFloat(form.ACVLSplitPct) || 0) / 100;
// // //     const vendorSplitPct = (parseFloat(form.vendorsplitPct) || 0) / 100;
// // //     const profitBase = subTotal + lead + ops;
// // //     const profit = profitBase * profitPct;
// // //     const total = profitBase + profit;
// // //     const acvlProfit = profit * acvlSplitPct;
// // //     const vendorProfit = profit * vendorSplitPct;

// // //     console.log('calculate:', {
// // //       subTotal,
// // //       lead,
// // //       ops,
// // //       profitPct,
// // //       profitBase,
// // //       profit,
// // //       total,
// // //       acvlProfit,
// // //       vendorProfit,
// // //       formState: {
// // //         totalLabourCost: form.totalLabourCost,
// // //         truckCost: form.truckCost,
// // //         fuelCost: form.fuelCost,
// // //         staircaseFee: form.staircaseFee,
// // //         longWalkCharges: form.longWalkCharges,
// // //       }
// // //     });

// // //     setTotalCost(isFinite(total) ? total : 0);
// // //     setBreakdown(
// // //       `Sub-Total: ${fmtMoney(subTotal)} • Labour: ${fmtMoney(
// // //         parseFloat(form.totalLabourCost) || 0
// // //       )} (Driver ${fmtMoney(parseFloat(form.driverCost) || 0)} + Helpers ${fmtMoney(
// // //         parseFloat(form.helpersCost) || 0
// // //       )}) • Truck: ${fmtMoney(
// // //         parseFloat(form.truckCost) || 0
// // //       )} • Fuel: ${fmtMoney(parseFloat(form.fuelCost) || 0)} • Stairs: ${fmtMoney(
// // //         parseFloat(form.staircaseFee) || 0
// // //       )} • Long Walk: ${fmtMoney(parseFloat(form.longWalkCharges) || 0)}
// // // Lead (5%): ${fmtMoney(lead)} • Ops (10%): ${fmtMoney(ops)} • Profit (${
// // //         form.profitPct || 0
// // //       }%): ${fmtMoney(profit)}
// // // ACVL Profit (${form.ACVLSplitPct || 0}%): ${fmtMoney(acvlProfit)} • Vendor Profit (${form.vendorsplitPct || 0}%): ${fmtMoney(vendorProfit)}
// // // Travel: Billable ${form.billableKm || 0} km → ${form.billableTimeHrs || 0} hrs; Non-billable ${
// // //         form.nonBillableKm || 0
// // //       } km → ${form.nonBillableTimeHrs || 0} hrs
// // // Loading ${form.loadingTimeHrs || 0} hrs • Unloading ${form.unloadingTimeHrs || 0} hrs
// // // Crew: ${form.numMen || 0} men • Move size: ${
// // //         form.moveSize || "-"
// // //       } • Est. Weight: ${form.estWeightLbs || 0} lbs • Truck: ${form.truckSize || "-"}`
// // //     );
// // //   };

// //   const autoFixedCosts = () => {
// //     const labour = parseFloat(form.totalLabourCost) || 0;
// //     const truck = parseFloat(form.truckCost) || 0; // Ensure truckCost is parsed correctly
// //     const fuel = parseFloat(form.fuelCost) || 0;
// //     const stairsFee = parseFloat(form.staircaseFee) || 0;
// //     const walkFee = parseFloat(form.longWalkCharges) || 0;
// //     const sub = labour + truck + fuel + stairsFee + walkFee;

// //     console.log('autoFixedCosts:', { labour, truck, fuel, stairsFee, walkFee, sub });

// //     updateForm({
// //       subTotal: isFinite(sub) ? sub.toFixed(2) : "0.00",
// //       leadCost: isFinite(sub) ? (sub * 0.05).toFixed(2) : "0.00",
// //       opsExpense: isFinite(sub) ? (sub * 0.10).toFixed(2) : "0.00",
// //     });
// //   };

// //   // const calculate = () => {
// //   //   autoLoadUnload();
// //   //   autoLabourCost();
// //   //   autoFuelCost();
// //   //   autoFixedCosts();

// //   //   const subTotal = parseFloat(form.subTotal) || 0;
// //   //   const lead = parseFloat(form.leadCost) || 0;
// //   //   const ops = parseFloat(form.opsExpense) || 0;
// //   //   const profitPct = (parseFloat(form.profitPct) || 0) / 100;
// //   //   const acvlSplitPct = (parseFloat(form.ACVLSplitPct) || 0) / 100;
// //   //   const vendorSplitPct = (parseFloat(form.vendorsplitPct) || 0) / 100;
// //   //   const profitBase = subTotal + lead + ops;
// //   //   const profit = profitBase * profitPct;
// //   //   const total = profitBase + profit;
// //   //   const acvlProfit = profit * acvlSplitPct;
// //   //   const vendorProfit = profit * vendorSplitPct;

// //   //   console.log('calculate:', {
// //   //     subTotal,
// //   //     lead,
// //   //     ops,
// //   //     profitPct,
// //   //     profitBase,
// //   //     profit,
// //   //     total,
// //   //     acvlProfit,
// //   //     vendorProfit,
// //   //     formState: {
// //   //       totalLabourCost: form.totalLabourCost,
// //   //       truckCost: form.truckCost,
// //   //       fuelCost: form.fuelCost,
// //   //       staircaseFee: form.staircaseFee,
// //   //       longWalkCharges: form.longWalkCharges,
// //   //     }
// //   //   });

// //   //   setTotalCost(isFinite(total) ? total : 0);
// //   //   setBreakdown(
// //   //     `Sub-Total: ${fmtMoney(subTotal)} • Labour: ${fmtMoney(parseFloat(form.totalLabourCost) || 0)} (Driver ${fmtMoney(parseFloat(form.driverCost) || 0)} + Helpers ${fmtMoney(parseFloat(form.helpersCost) || 0)}) • Truck: ${fmtMoney(parseFloat(form.truckCost) || 0)} • Fuel: ${fmtMoney(parseFloat(form.fuelCost) || 0)} • Stairs: ${fmtMoney(parseFloat(form.staircaseFee) || 0)} • Long Walk: ${fmtMoney(parseFloat(form.longWalkCharges) || 0)}
// //   // Lead (5%): ${fmtMoney(lead)} • Ops (10%): ${fmtMoney(ops)} • Profit (${form.profitPct || 0}%): ${fmtMoney(profit)}
// //   // ACVL Profit (${form.ACVLSplitPct || 0}%): ${fmtMoney(acvlProfit)} • Vendor Profit (${form.vendorsplitPct || 0}%): ${fmtMoney(vendorProfit)}
// //   // Travel: Billable ${form.billableKm || 0} km → ${form.billableTimeHrs || 0} hrs; Non-billable ${form.nonBillableKm || 0} km → ${form.nonBillableTimeHrs || 0} hrs
// //   // Loading ${form.loadingTimeHrs || 0} hrs • Unloading ${form.unloadingTimeHrs || 0} hrs
// //   // Crew: ${form.numMen || 0} men • Move size: ${form.moveSize || "-"} • Est. Weight: ${form.estWeightLbs || 0} lbs • Truck: ${form.truckSize || "-"}`
// //   //   );
// //   // };
 
//  const calculate = () => {
//   // autoLoadUnload
//   const w = parseFloat(form.estWeightLbs) || 0;
//   const men = parseInt(form.numMen) || 1;
//   const crewFactor = men / 2;
//   const loadHrs = crewFactor > 0 ? w / (650 * crewFactor) : 0;
//   const unloadHrs = crewFactor > 0 ? w / (850 * crewFactor) : 0;

//   // autoLabourCost
//   const bt = parseFloat(form.billableTimeHrs) || parseFloat(form.billableKm || 0) / 100 || 0;
//   const nbt = parseFloat(form.nonBillableTimeHrs) || parseFloat(form.nonBillableKm || 0) / 100 || 0;
//   const travel = bt + nbt;
//   const driverCost = (travel + loadHrs + unloadHrs) * 20;
//   const helpers = Math.max(0, men - 1);
//   const helperPer = (loadHrs + unloadHrs) * 20 + travel * 10;
//   const helpersCost = helpers * helperPer;
//   const totalLabourCost = driverCost + helpersCost;

//   // autoFuelCost
//   const billKm = parseFloat(form.billableKm) || 0;
//   const nonBillKm = parseFloat(form.nonBillableKm) || 0;
//   const totalKm = billKm + nonBillKm;
//   const fuelCost = (totalKm / 3.5) * 1.7;

//   // autoFixedCosts
//   const truck = parseFloat(form.truckCost) || 0;
//   const stairsFee = parseFloat(form.staircaseFee) || 0;
//   const walkFee = parseFloat(form.longWalkCharges) || 0;
//   const subTotal = totalLabourCost + truck + fuelCost + stairsFee + walkFee;
//   const leadCost = isFinite(subTotal) ? (subTotal * 0.05) : 0;
//   const opsExpense = isFinite(subTotal) ? (subTotal * 0.10) : 0;

//   // Final calculations
//   const profitPct = (parseFloat(form.profitPct) || 0) / 100;
//   const acvlSplitPct = (parseFloat(form.ACVLSplitPct) || 0) / 100;
//   const vendorSplitPct = (parseFloat(form.vendorsplitPct) || 0) / 100;
//   const profitBase = subTotal + leadCost + opsExpense;
//   const profit = profitBase * profitPct;
//   const total = profitBase + profit;
//   const acvlProfit = profit * acvlSplitPct;
//   const vendorProfit = profit * vendorSplitPct;

//   console.log('calculate:', {
//     loadHrs, unloadHrs,
//     bt, nbt, travel, driverCost, helpersCost, totalLabourCost,
//     billKm, nonBillKm, totalKm, fuelCost,
//     truck, stairsFee, walkFee, subTotal, leadCost, opsExpense,
//     profitPct, profitBase, profit, total, acvlProfit, vendorProfit,
//     formState: {
//       totalLabourCost: totalLabourCost.toFixed(2),
//       truckCost: truck.toFixed(2),
//       fuelCost: fuelCost.toFixed(2),
//       staircaseFee: stairsFee.toFixed(2),
//       longWalkCharges: walkFee.toFixed(2),
//     }
//   });
//   setTotalCost(isFinite(total) ? total : 0);
//   setBreakdown(
//     `Sub-Total: ${fmtMoney(subTotal)} • Labour: ${fmtMoney(totalLabourCost)} (Driver ${fmtMoney(driverCost)} + Helpers ${fmtMoney(helpersCost)}) • Truck: ${fmtMoney(truck)} • Fuel: ${fmtMoney(fuelCost)} • Stairs: ${fmtMoney(stairsFee)} • Long Walk: ${fmtMoney(walkFee)}
// Lead (5%): ${fmtMoney(leadCost)} • Ops (10%): ${fmtMoney(opsExpense)} • Profit (${form.profitPct || 0}%): ${fmtMoney(profit)}
// ACVL Profit (${form.ACVLSplitPct || 0}%): ${fmtMoney(acvlProfit)} • Vendor Profit (${form.vendorsplitPct || 0}%): ${fmtMoney(vendorProfit)}
// Travel: Billable ${billKm || 0} km → ${bt || 0} hrs; Non-billable ${nonBillKm || 0} km → ${nbt || 0} hrs
// Loading ${loadHrs.toFixed(2) || 0} hrs • Unloading ${unloadHrs.toFixed(2) || 0} hrs
// Crew: ${men || 0} men • Move size: ${form.moveSize || "-"} • Est. Weight: ${w || 0} lbs • Truck: ${form.truckSize || "-"}`
//   );
//   // Optional: Update form state if needed
//   updateForm({
//     loadingTimeHrs: loadHrs.toFixed(2),
//     unloadingTimeHrs: unloadHrs.toFixed(2),
//     driverCost: driverCost.toFixed(2),
//     helpersCost: helpersCost.toFixed(2),
//     totalLabourCost: totalLabourCost.toFixed(2),
//     fuelCost: fuelCost.toFixed(2),
//     subTotal: subTotal.toFixed(2),
//     leadCost: leadCost.toFixed(2),
//     opsExpense: opsExpense.toFixed(2),
//   });
// };
//   const fetchDistances = async () => {
//     setDistanceStatus('Looking up distances and times…');
//     setIsFetching(true);
//     setIsDistanceFetched(false);
//     try {
//       const { startingHub, stopHub, origin, destination } = form;
//       if (!(startingHub && stopHub && origin && destination)) {
//         setDistanceStatus('Please fill Starting Hub, Stop Hub, Origin, and Destination.');
//         setIsFetching(false);
//         return;
//       }

//       const response = await fetch('https://salesjet-10097049716.development.catalystappsail.com/api/calculate-distances', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ startingHub, stopHub, origin, destination }),
//       });

//       if (!response.ok) {
//         throw new Error('Failed to fetch distances from server.');
//       }

//       const data = await response.json();
//       const billableKm = parseFloat(data.billableKm) || 0;
//       const nonBillableKm = parseFloat(data.nonBillableKm) || 0;
//       const billableTimeHrs = parseFloat(data.billableTimeHrs) || billableKm / 100;
//       const nonBillableTimeHrs = parseFloat(data.nonBillableTimeHrs) || nonBillableKm / 100;

//       console.log('fetchDistances:', { billableKm, nonBillableKm, billableTimeHrs, nonBillableTimeHrs });

//       updateForm({
//         billableKm: isFinite(billableKm) ? billableKm.toFixed(1) : "0.0",
//         nonBillableKm: isFinite(nonBillableKm) ? nonBillableKm.toFixed(1) : "0.0",
//         billableTimeHrs: isFinite(billableTimeHrs) ? billableTimeHrs.toFixed(2) : "0.00",
//         nonBillableTimeHrs: isFinite(nonBillableTimeHrs) ? nonBillableTimeHrs.toFixed(2) : "0.00",
//       });
//       autoLoadUnload();
//       calculate();
//       setIsDistanceFetched(true);
//       setDistanceStatus(
//         `Updated ✓ Billable: ${isFinite(billableKm) ? billableKm.toFixed(1) : "0.0"} km (${isFinite(billableTimeHrs) ? billableTimeHrs.toFixed(2) : "0.00"} hrs) • Non-billable: ${isFinite(nonBillableKm) ? nonBillableKm.toFixed(1) : "0.0"} km (${isFinite(nonBillableTimeHrs) ? nonBillableTimeHrs.toFixed(2) : "0.00"} hrs)`
//       );
//     } catch (err) {
//       console.error('Fetch distances error:', err);
//       setDistanceStatus('Distance and time lookup failed. Check locations or try again.');
//       setIsDistanceFetched(false);
//     } finally {
//       setIsFetching(false);
//     }
//   };

//   const reset = () => {
//     const { moveSize: normalizedMoveSize, weight } = parseMoveSize(booking?.Move_Size);
//     const totalStairs = parseInt(booking?.NoOfStaircasesAtOrigin || 0) + parseInt(booking?.NoOfStaircasesAtDestination || 0);
//     const staircaseFee = getStaircaseFee(totalStairs);
//     const totalYards = parseFloat(booking?.LongWalkAtOrigin || 0) + parseFloat(booking?.LongWalkAtDestination || 0);
//     const longWalkCharges = getLongWalkCharges(totalYards);
//     setForm({
//       startingHub: "",
//       moveDate: booking?.Move_Date || "",
//       origin: booking?.FromAddress || booking?.OriginCity || "",
//       destination: booking?.ToAddress || booking?.DestinationCity || "",
//       stopHub: "",
//       billableKm: "",
//       nonBillableKm: "",
//       billableTimeHrs: "",
//       nonBillableTimeHrs: "",
//       moveSize: normalizedMoveSize,
//       estWeightLbs: weight || (normalizedMoveSize ? MOVE_WEIGHT[normalizedMoveSize] || "" : ""),
//       truckSize: normalizedMoveSize ? MOVE_TRUCK[normalizedMoveSize] || "" : "",
//       numMen: "2",
//       loadingTimeHrs: "",
//       unloadingTimeHrs: "",
//       driverCost: "",
//       helpersCost: "",
//       totalLabourCost: "",
//       truckCost: "200",
//       fuelCost: "",
//       subTotal: "",
//       leadCost: "0",
//       opsExpense: "0",
//       profitPct: "50",
//       ACVLSplitPct: "50",
//       vendorsplitPct: "50",
//       staircaseFee: staircaseFee ? staircaseFee.toFixed(2) : "0.00",
//       longWalkCharges: longWalkCharges ? longWalkCharges.toFixed(2) : "0.00",
//     });
//     setDistanceStatus("Billable = Origin → Destination. Non-billable = Start Hub → Origin + Destination → Stop Hub.");
//     setTotalCost(0);
//     setBreakdown("");
//     setIsDistanceFetched(false);
//     setIsFetching(false);
//     setCollapsedSections({
//       jobDetails: true,
//       moveDetails: true,
//       distanceCost: true,
//       results: false,
//     });
//   };

//   const toggleSection = (section) => {
//     setCollapsedSections((prev) => ({
//       ...prev,
//       [section]: !prev[section],
//     }));
//   };

//   // const SelectField = ({ id, label, options, hint, onChange }) => (
//   //   <div>
//   //     <label htmlFor={id}>{label}</label>
//   //     <select
//   //       id={id}
//   //       value={form[id] || ""}
//   //       onChange={onChange || ((e) => {
//   //         updateForm({ [id]: e.target.value });
//   //         if (id === "startingHub" || id === "stopHub") {
//   //           fetchDistances();
//   //         }
//   //       })}
//   //     >
//   //       {options.map((opt) => (
//   //         <option key={opt.value} value={opt.value}>{opt.label}</option>
//   //       ))}
//   //     </select>
//   //     {hint && <div className="cost_hint">{hint}</div>}
//   //   </div>
//   // );

//   const ComboField = ({ id, label, options, hint }) => (
//     <div>
//       <label htmlFor={id}>{label}</label>
//       <input
//         id={id}
//         type="text"
//         list={`${id}-datalist`}
//         value={form[id] || ""}
//         onChange={(e) => {
//           updateForm({ [id]: e.target.value });
//           if (id === "startingHub" || id === "stopHub") {
//             fetchDistances();
//           }
//         }}
//         placeholder="Type location or select hub..."
//       />
//       <datalist id={`${id}-datalist`}>
//         {options.map((opt) => (
//           <option key={opt.value} value={opt.value}>
//             {opt.label}
//           </option>
//         ))}
//       </datalist>
//       {hint && <div className="cost_hint">{hint}</div>}
//     </div>
//   );

//   return (
//     <div className="cost_wrap">
//       <main className="cost_wrap">
//         <section className="cost_card">
//           <div className="cost_row" style={{ justifyContent: "space-between" }}>
//             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Job Details</h2>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <span className="cost_pill">All distances in KM • Times from Google Maps</span>
//               <button
//                 onClick={() => toggleSection("jobDetails")}
//                 style={{
//                   marginLeft: "10px",
//                   fontSize: "1.2rem",
//                   cursor: "pointer",
//                   color: "#333",
//                   border: "none",
//                   background: "none",
//                 }}
//               >
//                 {collapsedSections.jobDetails ? "+" : "−"}
//               </button>
//             </div>
//           </div>
//           <div className="cost_bar"></div>
//           {!collapsedSections.jobDetails && (
//             <div className="cost_grid cost_cols-3">
//               <div>
//                 <label htmlFor="origin">Origin (City, Province)</label>
//                 <div className="cost_unit">
//                   <input
//                     id="origin"
//                     type="text"
//                     placeholder="City, ST, Country or lat,lon"
//                     value={form.origin || ""}
//                     onChange={(e) => updateForm({ origin: e.target.value })}
//                     readOnly
//                   />
//                 </div>
//               </div>
//               <div>
//                 <label htmlFor="destination">Destination (City, Province)</label>
//                 <div className="cost_unit">
//                   <input
//                     id="destination"
//                     type="text"
//                     placeholder="City, ST, Country or lat,lon"
//                     value={form.destination || ""}
//                     onChange={(e) => updateForm({ destination: e.target.value })}
//                     readOnly
//                   />
//                 </div>
//               </div>
//               <div>
//                 <label htmlFor="moveDate">Move Date</label>
//                 <div className="cost_unit">
//                   <input
//                     id="moveDate"
//                     type="text"
//                     placeholder="YYYY-MM-DD"
//                     value={form.moveDate || ""}
//                     onChange={(e) => updateForm({ moveDate: e.target.value })}
//                     readOnly
//                   />
//                 </div>
//               </div>
//               <div>
//                 <label htmlFor="moveSize">Move Size (Bedrooms)</label>
//                 <div className="cost_unit">
//                   <input
//                     id="moveSize"
//                     type="text"
//                     placeholder="Select size…"
//                     value={moveSizes.find(opt => opt.value === form.moveSize)?.label || form.moveSize || ""}
//                     readOnly
//                   />
//                 </div>
//               </div>
//             </div>
//           )}
//         </section>

//         <section className="cost_card">
//           <div className="cost_row" style={{ justifyContent: "space-between" }}>
//             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Move Details & Profit Range</h2>
//             <button
//               onClick={() => toggleSection("moveDetails")}
//               style={{
//                 fontSize: "1.2rem",
//                 cursor: "pointer",
//                 color: "#333",
//                 border: "none",
//                 background: "none",
//               }}
//             >
//               {collapsedSections.moveDetails ? "+" : "−"}
//             </button>
//           </div>
//           <div className="cost_bar"></div>
//           {!collapsedSections.moveDetails && (
//             <>
//               <div className="cost_grid cost_cols-3">
//                 <ComboField
//                   id="startingHub"
//                   label="Starting Location (Hub)"
//                   options={hubs}
//                 />
//                 <ComboField
//                   id="stopHub"
//                   label="Stop Location (Hub)"
//                   options={hubs}
//                 />
//               </div>
//               <div className="cost_btns" style={{ marginTop: "8px", position: "relative" }}>
//                 <button
//                   type="button"
//                   onClick={fetchDistances}
//                   className={isDistanceFetched ? "cost_fetched" : isFetching ? "cost_fetching" : ""}
//                 >
//                   Fetch distances and times (Google Maps)
//                   {isFetching && (
//                     <span className="spinner" style={{ marginLeft: "8px" }}>↻</span>
//                   )}
//                 </button>
//               </div>
//               <div className="cost_grid cost_cols-3" style={{ marginTop: "10px" }}>
//                 <div>
//                   <label htmlFor="estWeightLbs">Estimated Weight</label>
//                   <div className="cost_unit">
//                     <input
//                       id="estWeightLbs"
//                       type="number"
//                       min="0"
//                       step="1"
//                       placeholder="0"
//                       value={form.estWeightLbs || ""}
//                       onChange={(e) => {
//                         updateForm({ estWeightLbs: e.target.value });
//                         autoLoadUnload();
//                         calculate();
//                       }}
//                     />
//                     <span>lbs</span>
//                   </div>
//                 </div>
//                 <div>
//                   <label htmlFor="truckSize">Truck Size</label>
//                   <div className="cost_unit">
//                     <input
//                       id="truckSize"
//                       type="text"
//                       placeholder="e.g., 16 ft / 20 ft / 26 ft"
//                       value={form.truckSize || ""}
//                       onChange={(e) => updateForm({ truckSize: e.target.value })}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label htmlFor="numMen">Number of Men</label>
//                   <div className="cost_unit">
//                     <input
//                       id="numMen"
//                       type="number"
//                       min="1"
//                       step="1"
//                       placeholder="2"
//                       value={form.numMen || ""}
//                       onChange={(e) => {
//                         updateForm({ numMen: e.target.value });
//                         autoLoadUnload();
//                         calculate();
//                       }}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label htmlFor="truckCost">Truck Cost</label>
//                   <div className="cost_unit">
//                     <input
//                       id="truckCost"
//                       type="number"
//                       min="0"
//                       step="0.01"
//                       placeholder="200"
//                       value={form.truckCost || ""}
//                       onChange={(e) => {
//                         updateForm({ truckCost: e.target.value });
//                         calculate();
//                       }}
//                     />
//                     <span>$</span>
//                   </div>
//                   <div className="cost_hint">Enter truck rental or usage cost manually.</div>
//                 </div>
//                 <div>
//                   <label htmlFor="profitPct">Profit Percentage</label>
//                   <div className="cost_unit">
//                     <input
//                       id="profitPct"
//                       type="number"
//                       min="0"
//                       step="0.1"
//                       placeholder="50"
//                       value={form.profitPct || ""}
//                       onChange={(e) => {
//                         updateForm({ profitPct: e.target.value });
//                         calculate();
//                       }}
//                     />
//                     <span>%</span>
//                   </div>
//                   <div className="cost_hint">Applied to (Sub-Total + Lead + Ops)</div>
//                 </div>
//                 <div>
//                   <label htmlFor="ACVLSplitPct">ACVL Profit Split</label>
//                   <div className="cost_unit">
//                     <input
//                       id="ACVLSplitPct"
//                       type="number"
//                       min="0"
//                       max="100"
//                       step="0.1"
//                       placeholder="50"
//                       value={form.ACVLSplitPct || ""}
//                       onChange={(e) => {
//                         updateForm({ ACVLSplitPct: e.target.value });
//                         calculate();
//                       }}
//                     />
//                     <span>%</span>
//                   </div>
//                 </div>
//                 <div>
//                   <label htmlFor="vendorsplitPct">Vendor Profit Split</label>
//                   <div className="cost_unit">
//                     <input
//                       id="vendorsplitPct"
//                       type="number"
//                       min="0"
//                       max="100"
//                       step="0.1"
//                       placeholder="50"
//                       value={form.vendorsplitPct || ""}
//                       readOnly
//                     />
//                     <span>%</span>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </section>

//         <section className="cost_card">
//           <div className="cost_row" style={{ justifyContent: "space-between" }}>
//             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Distance, Cost & Time Calculations</h2>
//             <button
//               onClick={() => toggleSection("distanceCost")}
//               style={{
//                 fontSize: "1.2rem",
//                 cursor: "pointer",
//                 border: "none",
//                 color: "#333",
//                 background: "none",
//               }}
//             >
//               {collapsedSections.distanceCost ? "+" : "−"}
//             </button>
//           </div>
//           <div className="cost_bar"></div>
//           {!collapsedSections.distanceCost && (
//             <div className="cost_grid cost_cols-2">
//               <div>
//                 <label htmlFor="billableKm">Billable Distance</label>
//                 <div className="cost_unit">
//                   <input
//                     id="billableKm"
//                     type="number"
//                     min="0"
//                     step="0.1"
//                     placeholder="0"
//                     value={form.billableKm || ""}
//                     onChange={(e) => {
//                       updateForm({ billableKm: e.target.value });
//                       calculate();
//                     }}
//                   />
//                   <span>km</span>
//                 </div>
//                 <div className="cost_hint">Origin → Destination</div>
//               </div>
//               <div>
//                 <label htmlFor="nonBillableKm">Non-Billable Distance</label>
//                 <div className="cost_unit">
//                   <input
//                     id="nonBillableKm"
//                     type="number"
//                     min="0"
//                     step="0.1"
//                     placeholder="0"
//                     value={form.nonBillableKm || ""}
//                     onChange={(e) => {
//                       updateForm({ nonBillableKm: e.target.value });
//                       calculate();
//                     }}
//                   />
//                   <span>km</span>
//                 </div>
//                 <div className="cost_hint">Start Hub → Origin + Destination → Stop Hub</div>
//               </div>
//               <div>
//                 <label htmlFor="billableTimeHrs">Billable Travel Time</label>
//                 <div className="cost_unit">
//                   <input
//                     id="billableTimeHrs"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.billableTimeHrs || ""}
//                     readOnly
//                   />
//                   <span>hrs</span>
//                 </div>
//                 <div className="cost_hint">Fetched from Google Maps or estimated as Billable Km / 100</div>
//               </div>
//               <div>
//                 <label htmlFor="nonBillableTimeHrs">Non-Billable Travel Time</label>
//                 <div className="cost_unit">
//                   <input
//                     id="nonBillableTimeHrs"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.nonBillableTimeHrs || ""}
//                     readOnly
//                   />
//                   <span>hrs</span>
//                 </div>
//                 <div className="cost_hint">Fetched from Google Maps or estimated as Non-Billable Km / 100</div>
//               </div>
//               <div>
//                 <label htmlFor="loadingTimeHrs">Loading Time</label>
//                 <div className="cost_unit">
//                   <input
//                     id="loadingTimeHrs"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.loadingTimeHrs || ""}
//                     readOnly
//                   />
//                   <span>hrs</span>
//                 </div>
//                 <div className="cost_hint">Capacity: 650 lbs/hour by 2 men (scaled by crew size).</div>
//               </div>
//               <div>
//                 <label htmlFor="unloadingTimeHrs">Unloading Time</label>
//                 <div className="cost_unit">
//                   <input
//                     id="unloadingTimeHrs"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.unloadingTimeHrs || ""}
//                     readOnly
//                   />
//                   <span>hrs</span>
//                 </div>
//                 <div className="cost_hint">Capacity: 850 lbs/hour by 2 men (scaled by crew size).</div>
//               </div>
//               <div>
//                 <label htmlFor="driverCost">Driver Cost</label>
//                 <div className="cost_unit">
//                   <input
//                     id="driverCost"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.driverCost || ""}
//                     readOnly
//                   />
//                   <span>$</span>
//                 </div>
//                 <div className="cost_hint">(Billable + Non-billable + Loading + Unloading) × $20</div>
//               </div>
//               <div>
//                 <label htmlFor="helpersCost">Helpers Cost</label>
//                 <div className="cost_unit">
//                   <input
//                     id="helpersCost"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.helpersCost || ""}
//                     readOnly
//                   />
//                   <span>$</span>
//                 </div>
//                 <div className="cost_hint">Per helper: (Loading + Unloading) × $20 + (Travel × $10) × helpers (men − 1)</div>
//               </div>
//               <div>
//                 <label htmlFor="totalLabourCost">Total Labour Cost</label>
//                 <div className="cost_unit">
//                   <input
//                     id="totalLabourCost"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.totalLabourCost || ""}
//                     readOnly
//                   />
//                   <span>$</span>
//                 </div>
//               </div>
//               <div>
//                 <label htmlFor="fuelCost">Fuel Cost (auto)</label>
//                 <div className="cost_unit">
//                   <input
//                     id="fuelCost"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.fuelCost || ""}
//                     readOnly
//                   />
//                   <span>$</span>
//                 </div>
//                 <div className="cost_hint">Fuel = ((Billable Distance + Non-billable Distance) ÷ 3.5) × 1.7</div>
//               </div>
//               <div>
//                 <label htmlFor="staircaseFee">Staircase Fee</label>
//                 <div className="cost_unit">
//                   <input
//                     id="staircaseFee"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.staircaseFee || ""}
//                     readOnly
//                   />
//                   <span>$</span>
//                 </div>
//                 <div className="cost_hint">Staircase Fee</div>
//               </div>
//               <div>
//                 <label htmlFor="longWalkCharges">Long Walk Charges</label>
//                 <div className="cost_unit">
//                   <input
//                     id="longWalkCharges"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.longWalkCharges || ""}
//                     readOnly
//                   />
//                   <span>$</span>
//                 </div>
//                 <div className="cost_hint">Long Walk Charges</div>
//               </div>
//               <div>
//                 <label htmlFor="subTotal">Sub-Total</label>
//                 <div className="cost_unit">
//                   <input
//                     id="subTotal"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.subTotal || ""}
//                     readOnly
//                   />
//                   <span>$</span>
//                 </div>
//                 <div className="cost_hint">Sub-Total = Labour + Truck + Fuel + Stairs + Long Walk</div>
//               </div>
//               <div>
//                 <label htmlFor="leadCost">Lead Cost (auto)</label>
//                 <div className="cost_unit">
//                   <input
//                     id="leadCost"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.leadCost || ""}
//                     readOnly
//                   />
//                   <span>$</span>
//                 </div>
//                 <div className="cost_hint">Lead = Sub-Total × 0.05</div>
//               </div>
//               <div>
//                 <label htmlFor="opsExpense">Ops Expense (Chennai) (auto)</label>
//                 <div className="cost_unit">
//                   <input
//                     id="opsExpense"
//                     type="number"
//                     min="0"
//                     step="0.01"
//                     placeholder="0"
//                     value={form.opsExpense || ""}
//                     readOnly
//                   />
//                   <span>$</span>
//                 </div>
//                 <div className="cost_hint">Ops = Sub-Total × 0.10</div>
//               </div>
//             </div>
//           )}
//         </section>

//         <section className="cost_card">
//           <div className="cost_row" style={{ justifyContent: "space-between" }}>
//             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Results</h2>
//           </div>
//           <div className="cost_bar"></div>
//           {!collapsedSections.results && (
//             <>
//               <div className="cost_btns">
//                 <button onClick={reset}>Reset</button>
//               </div>
//               <div className="cost_grid cost_cols-2">
//                 <div className="cost_out">
//                   <div className="cost_hint">Estimated Total</div>
//                   <div className="cost_tot" id="totalCostDisplay">{fmtMoney(totalCost)}</div>
//                   <div className="cost_note">Live formulas based on your rules.</div>
//                 </div>
//                 <div className="cost_out">
//                   <div className="cost_hint">Breakdown</div>
//                   <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>{breakdown}</pre>
//                 </div>
//               </div>
//             </>
//           )}
//         </section>
//       </main>
//     </div>
//   );
// };

// export default MoveCostCalculator;
import React, { useState, useEffect } from "react";
import './CostCalculator.css';

const MoveCostCalculator = ({ booking }) => {
  const MOVE_WEIGHT = {
    studio: 1500,
    "1br": 2500,
    "2br": 4000,
    "3br": 6000,
    "4br": 8000,
  };

  const MOVE_TRUCK = {
    studio: "16 ft",
    "1br": "16–20 ft",
    "2br": "20–22 ft",
    "3br": "26 ft",
    "4br": "26+ ft / 5-ton",
  };

  const hubs = [
    { value: "", label: "" },
    { value: "43.6532,-79.3832", label: "Toronto Hub" },
    { value: "49.2827,-123.1207", label: "Vancouver Hub" },
    { value: "51.0447,-114.0719", label: "Calgary Hub" },
  ];

  const moveSizes = [
    { value: "", label: "Select size…" },
    { value: "studio", label: "Studio" },
    { value: "1br", label: "1 Bedroom" },
    { value: "2br", label: "2 Bedroom" },
    { value: "3br", label: "3 Bedroom" },
    { value: "4br", label: "4 Bedroom" },
  ];

  const normalizeMoveSize = (moveSize) => {
    const moveSizeMap = {
      Studio: "studio",
      "1 Bedroom": "1br",
      "2 Bedroom": "2br",
      "3 Bedroom": "3br",
      "4 Bedroom": "4br",
    };
    return moveSizeMap[moveSize] || (typeof moveSize === 'string' ? moveSize.toLowerCase() : '');
  };

  const parseMoveSize = (input) => {
    if (!input || typeof input !== 'string') return { moveSize: "", weight: "" };
    const match = input.match(/(.*?)(\d+)\s*lbs$/i);
    if (match) {
      const rawSize = match[1].trim();
      const weight = match[2];
      const normalizedSize = normalizeMoveSize(rawSize);
      return { moveSize: normalizedSize, weight };
    } else {
      return { moveSize: normalizeMoveSize(input), weight: "" };
    }
  };

  const getStaircaseFee = (stairs) => {
    const numStairs = parseInt(stairs) || 0;
    if (numStairs >= 40) return 600;
    if (numStairs >= 30) return 450;
    if (numStairs >= 20) return 300;
    if (numStairs >= 10) return 150;
    return 0;
  };

  const getLongWalkCharges = (yards) => {
    const numYards = parseFloat(yards) || 0;
    if (numYards >= 150) return 300;
    if (numYards >= 100) return 250;
    if (numYards >= 50) return 200;
    if (numYards >= 40) return 150;
    return 0;
  };

  const [form, setForm] = useState({
    startingHub: "",
    moveDate: booking?.Move_Date || "",
    origin: booking?.FromAddress || booking?.OriginCity || "",
    destination: booking?.ToAddress || booking?.DestinationCity || "",
    staircaseFee: "",
    longWalkCharges: "",
    stopHub: "",
    billableKm: "",
    nonBillableKm: "",
    billableTimeHrs: "",
    nonBillableTimeHrs: "",
    moveSize: "",
    estWeightLbs: "",
    truckSize: "",
    numMen: "2",
    loadingTimeHrs: "",
    unloadingTimeHrs: "",
    driverCost: "",
    helpersCost: "",
    totalLabourCost: "",
    truckCost: "200",
    fuelCost: "",
    subTotal: "",
    leadCost: "0",
    opsExpense: "0",
    profitPct: "50",
    ACVLSplitPct: "50",
    vendorsplitPct: "50",
  });

  const [distanceStatus, setDistanceStatus] = useState(
    "Billable = Origin → Destination. Non-billable = Start Hub → Origin + Destination → Stop Hub."
  );
  const [totalCost, setTotalCost] = useState(0);
  const [breakdown, setBreakdown] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [isDistanceFetched, setIsDistanceFetched] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [collapsedSections, setCollapsedSections] = useState({
    jobDetails: true,
    moveDetails: true,
    distanceCost: true,
    results: false,
  });

  useEffect(() => {
    const fetchApiKey = async () => {
      try {
        const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/api/get-google-api-key");
        const data = await response.json();
        setApiKey(data.apiKey || "");
      } catch (error) {
        console.error("Failed to fetch API key:", error);
        setDistanceStatus("Error fetching API key.");
      }
    };

    fetchApiKey();

    const { moveSize: normalizedMoveSize, weight } = parseMoveSize(booking?.Move_Size);
    const totalStairs = parseInt(booking?.NoOfStaircasesAtOrigin || 0) + parseInt(booking?.NoOfStaircasesAtDestination || 0);
    const staircaseFee = getStaircaseFee(totalStairs);
    const totalYards = parseFloat(booking?.LongWalkAtOrigin || 0) + parseFloat(booking?.LongWalkAtDestination || 0);
    const longWalkCharges = getLongWalkCharges(totalYards);
    const updates = {
      origin: booking?.FromAddress || booking?.OriginCity || "",
      destination: booking?.ToAddress || booking?.DestinationCity || "",
      moveSize: normalizedMoveSize,
      estWeightLbs: weight || (normalizedMoveSize ? MOVE_WEIGHT[normalizedMoveSize] || "" : ""),
      truckSize: normalizedMoveSize ? MOVE_TRUCK[normalizedMoveSize] || "" : "",
      staircaseFee: staircaseFee ? staircaseFee.toFixed(2) : "0.00",
      longWalkCharges: longWalkCharges ? longWalkCharges.toFixed(2) : "0.00",
    };
    setForm((prev) => ({ ...prev, ...updates }));
    if (normalizedMoveSize || weight) {
      autoLoadUnload();
      calculate();
    }
  }, [booking]);

  useEffect(() => {
    if (
      form.billableKm ||
      form.nonBillableKm ||
      form.estWeightLbs ||
      form.numMen ||
      form.truckCost ||
      form.profitPct ||
      form.ACVLSplitPct ||
      form.staircaseFee ||
      form.longWalkCharges
    ) {
      calculate();
    }
  }, [
    form.billableKm,
    form.nonBillableKm,
    form.estWeightLbs,
    form.numMen,
    form.truckCost,
    form.profitPct,
    form.ACVLSplitPct,
    form.staircaseFee,
    form.longWalkCharges,
  ]);

  const fmtMoney = (v) => {
    const num = parseFloat(v);
    return isFinite(num) ? (num < 0 ? "-$" : "$") + Math.abs(num).toFixed(2) : "$0.00";
  };

  const updateForm = (updates) => {
    setForm((prev) => {
      const newForm = { ...prev, ...updates };
      if (updates.ACVLSplitPct !== undefined) {
        const acvlSplit = parseFloat(updates.ACVLSplitPct) || 0;
        newForm.vendorsplitPct = (100 - acvlSplit).toFixed(1);
      }
      return newForm;
    });
  };

  const autoLoadUnload = () => {
    const w = parseFloat(form.estWeightLbs) || 0;
    const men = parseInt(form.numMen) || 1;
    const crewFactor = men / 2;
    const loadHrs = crewFactor > 0 ? w / (650 * crewFactor) : 0;
    const unloadHrs = crewFactor > 0 ? w / (850 * crewFactor) : 0;

    console.log('autoLoadUnload:', { w, men, crewFactor, loadHrs, unloadHrs });

    updateForm({
      loadingTimeHrs: isFinite(loadHrs) ? loadHrs.toFixed(2) : "0.00",
      unloadingTimeHrs: isFinite(unloadHrs) ? unloadHrs.toFixed(2) : "0.00",
    });
  };

 const calculate = () => {
  // autoLoadUnload
  const w = parseFloat(form.estWeightLbs) || 0;
  const men = parseInt(form.numMen) || 1;
  const crewFactor = men / 2;
  const loadHrs = crewFactor > 0 ? w / (650 * crewFactor) : 0;
  const unloadHrs = crewFactor > 0 ? w / (850 * crewFactor) : 0;

  // autoLabourCost
  const bt = parseFloat(form.billableTimeHrs) || parseFloat(form.billableKm || 0) / 100 || 0;
  const nbt = parseFloat(form.nonBillableTimeHrs) || parseFloat(form.nonBillableKm || 0) / 100 || 0;
  const travel = bt + nbt;
  const driverCost = (travel + loadHrs + unloadHrs) * 20;
  const helpers = Math.max(0, men - 1);
  const helperPer = (loadHrs + unloadHrs) * 20 + travel * 10;
  const helpersCost = helpers * helperPer;
  const totalLabourCost = driverCost + helpersCost;

  // autoFuelCost
  const billKm = parseFloat(form.billableKm) || 0;
  const nonBillKm = parseFloat(form.nonBillableKm) || 0;
  const totalKm = billKm + nonBillKm;
  const fuelCost = (totalKm / 3.5) * 1.7;

  // autoFixedCosts
  const truck = parseFloat(form.truckCost) || 0;
  const stairsFee = parseFloat(form.staircaseFee) || 0;
  const walkFee = parseFloat(form.longWalkCharges) || 0;
  const subTotal = totalLabourCost + truck + fuelCost + stairsFee + walkFee;
  const leadCost = isFinite(subTotal) ? (subTotal * 0.05) : 0;
  const opsExpense = isFinite(subTotal) ? (subTotal * 0.10) : 0;

  // Final calculations
  const profitPct = (parseFloat(form.profitPct) || 0) / 100;
  const acvlSplitPct = (parseFloat(form.ACVLSplitPct) || 0) / 100;
  const vendorSplitPct = (parseFloat(form.vendorsplitPct) || 0) / 100;
  const profitBase = subTotal + leadCost + opsExpense;
  const profit = profitBase * profitPct;
  const total = profitBase + profit;
  const acvlProfit = profit * acvlSplitPct;
  const vendorProfit = profit * vendorSplitPct;

  console.log('calculate:', {
    loadHrs, unloadHrs,
    bt, nbt, travel, driverCost, helpersCost, totalLabourCost,
    billKm, nonBillKm, totalKm, fuelCost,
    truck, stairsFee, walkFee, subTotal, leadCost, opsExpense,
    profitPct, profitBase, profit, total, acvlProfit, vendorProfit,
    formState: {
      totalLabourCost: totalLabourCost.toFixed(2),
      truckCost: truck.toFixed(2),
      fuelCost: fuelCost.toFixed(2),
      staircaseFee: stairsFee.toFixed(2),
      longWalkCharges: walkFee.toFixed(2),
    }
  });
  setTotalCost(isFinite(total) ? total : 0);
  setBreakdown(
    `Sub-Total: ${fmtMoney(subTotal)} • Labour: ${fmtMoney(totalLabourCost)} (Driver ${fmtMoney(driverCost)} + Helpers ${fmtMoney(helpersCost)}) • Truck: ${fmtMoney(truck)} • Fuel: ${fmtMoney(fuelCost)} • Stairs: ${fmtMoney(stairsFee)} • Long Walk: ${fmtMoney(walkFee)}
Lead (5%): ${fmtMoney(leadCost)} • Ops (10%): ${fmtMoney(opsExpense)} • Profit (${form.profitPct || 0}%): ${fmtMoney(profit)}
ACVL Profit (${form.ACVLSplitPct || 0}%): ${fmtMoney(acvlProfit)} • Vendor Profit (${form.vendorsplitPct || 0}%): ${fmtMoney(vendorProfit)}
Travel: Billable ${billKm || 0} km → ${bt || 0} hrs; Non-billable ${nonBillKm || 0} km → ${nbt || 0} hrs
Loading ${loadHrs.toFixed(2) || 0} hrs • Unloading ${unloadHrs.toFixed(2) || 0} hrs
Crew: ${men || 0} men • Move size: ${form.moveSize || "-"} • Est. Weight: ${w || 0} lbs • Truck: ${form.truckSize || "-"}`
  );
  // Optional: Update form state if needed
  updateForm({
    loadingTimeHrs: loadHrs.toFixed(2),
    unloadingTimeHrs: unloadHrs.toFixed(2),
    driverCost: driverCost.toFixed(2),
    helpersCost: helpersCost.toFixed(2),
    totalLabourCost: totalLabourCost.toFixed(2),
    fuelCost: fuelCost.toFixed(2),
    subTotal: subTotal.toFixed(2),
    leadCost: leadCost.toFixed(2),
    opsExpense: opsExpense.toFixed(2),
  });
};
  const fetchDistances = async () => {
    setDistanceStatus('Looking up distances and times…');
    setIsFetching(true);
    setIsDistanceFetched(false);
    try {
      const { startingHub, stopHub, origin, destination } = form;
      if (!(startingHub && stopHub && origin && destination)) {
        setDistanceStatus('Please fill Starting Hub, Stop Hub, Origin, and Destination.');
        setIsFetching(false);
        return;
      }

      const response = await fetch('https://salesjet-10097049716.development.catalystappsail.com/api/calculate-distances', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ startingHub, stopHub, origin, destination }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch distances from server.');
      }

      const data = await response.json();
      const billableKm = parseFloat(data.billableKm) || 0;
      const nonBillableKm = parseFloat(data.nonBillableKm) || 0;
      const billableTimeHrs = parseFloat(data.billableTimeHrs) || billableKm / 100;
      const nonBillableTimeHrs = parseFloat(data.nonBillableTimeHrs) || nonBillableKm / 100;

      console.log('fetchDistances:', { billableKm, nonBillableKm, billableTimeHrs, nonBillableTimeHrs });

      updateForm({
        billableKm: isFinite(billableKm) ? billableKm.toFixed(1) : "0.0",
        nonBillableKm: isFinite(nonBillableKm) ? nonBillableKm.toFixed(1) : "0.0",
        billableTimeHrs: isFinite(billableTimeHrs) ? billableTimeHrs.toFixed(2) : "0.00",
        nonBillableTimeHrs: isFinite(nonBillableTimeHrs) ? nonBillableTimeHrs.toFixed(2) : "0.00",
      });
      autoLoadUnload();
      calculate();
      setIsDistanceFetched(true);
      setDistanceStatus(
        `Updated ✓ Billable: ${isFinite(billableKm) ? billableKm.toFixed(1) : "0.0"} km (${isFinite(billableTimeHrs) ? billableTimeHrs.toFixed(2) : "0.00"} hrs) • Non-billable: ${isFinite(nonBillableKm) ? nonBillableKm.toFixed(1) : "0.0"} km (${isFinite(nonBillableTimeHrs) ? nonBillableTimeHrs.toFixed(2) : "0.00"} hrs)`
      );
    } catch (err) {
      console.error('Fetch distances error:', err);
      setDistanceStatus('Distance and time lookup failed. Check locations or try again.');
      setIsDistanceFetched(false);
    } finally {
      setIsFetching(false);
    }
  };

  const reset = () => {
    const { moveSize: normalizedMoveSize, weight } = parseMoveSize(booking?.Move_Size);
    const totalStairs = parseInt(booking?.NoOfStaircasesAtOrigin || 0) + parseInt(booking?.NoOfStaircasesAtDestination || 0);
    const staircaseFee = getStaircaseFee(totalStairs);
    const totalYards = parseFloat(booking?.LongWalkAtOrigin || 0) + parseFloat(booking?.LongWalkAtDestination || 0);
    const longWalkCharges = getLongWalkCharges(totalYards);
    setForm({
      startingHub: "",
      moveDate: booking?.Move_Date || "",
      origin: booking?.FromAddress || booking?.OriginCity || "",
      destination: booking?.ToAddress || booking?.DestinationCity || "",
      stopHub: "",
      billableKm: "",
      nonBillableKm: "",
      billableTimeHrs: "",
      nonBillableTimeHrs: "",
      moveSize: normalizedMoveSize,
      estWeightLbs: weight || (normalizedMoveSize ? MOVE_WEIGHT[normalizedMoveSize] || "" : ""),
      truckSize: normalizedMoveSize ? MOVE_TRUCK[normalizedMoveSize] || "" : "",
      numMen: "2",
      loadingTimeHrs: "",
      unloadingTimeHrs: "",
      driverCost: "",
      helpersCost: "",
      totalLabourCost: "",
      truckCost: "200",
      fuelCost: "",
      subTotal: "",
      leadCost: "0",
      opsExpense: "0",
      profitPct: "50",
      ACVLSplitPct: "50",
      vendorsplitPct: "50",
      staircaseFee: staircaseFee ? staircaseFee.toFixed(2) : "0.00",
      longWalkCharges: longWalkCharges ? longWalkCharges.toFixed(2) : "0.00",
    });
    setDistanceStatus("Billable = Origin → Destination. Non-billable = Start Hub → Origin + Destination → Stop Hub.");
    setTotalCost(0);
    setBreakdown("");
    setIsDistanceFetched(false);
    setIsFetching(false);
    setCollapsedSections({
      jobDetails: true,
      moveDetails: true,
      distanceCost: true,
      results: false,
    });
  };

  const toggleSection = (section) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const ComboField = ({ id, label, options, hint, onFieldUpdate }) => {
    const getDisplayValue = (storedValue) => {
      const matchedOption = options.find((opt) => opt.value === storedValue);
      return matchedOption ? matchedOption.label : storedValue;
    };

    const [inputValue, setInputValue] = useState(getDisplayValue(form[id] || ""));

    useEffect(() => {
      setInputValue(getDisplayValue(form[id] || ""));
    }, [form[id], id, options]);

    const handleChange = (e) => {
      setInputValue(e.target.value);
    };

    const handleBlur = () => {
      const matchedOption = options.find((opt) => opt.label === inputValue);
      const finalValue = matchedOption ? matchedOption.value : inputValue;
      updateForm({ [id]: finalValue });
      if (onFieldUpdate) {
        onFieldUpdate(finalValue);
      }
    };

    const handleFocus = (e) => {
      e.target.select();
    };

    return (
      <div>
        <label htmlFor={id}>{label}</label>
        <input
          id={id}
          type="text"
          list={`${id}-datalist`}
          value={inputValue}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          placeholder="Type location or select hub..."
        />
        <datalist id={`${id}-datalist`}>
          {options.map((opt) => (
            <option key={opt.value} value={opt.label}>
              {opt.label}
            </option>
          ))}
        </datalist>
        {hint && <div className="cost_hint">{hint}</div>}
      </div>
    );
  };

  return (
    <div className="cost_wrap">
      <main className="cost_wrap">
        <section className="cost_card">
          <div className="cost_row" style={{ justifyContent: "space-between" }}>
            <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Job Details</h2>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span className="cost_pill">All distances in KM • Times from Google Maps</span>
              <button
                onClick={() => toggleSection("jobDetails")}
                style={{
                  marginLeft: "10px",
                  fontSize: "1.2rem",
                  cursor: "pointer",
                  color: "#333",
                  border: "none",
                  background: "none",
                }}
              >
                {collapsedSections.jobDetails ? "+" : "−"}
              </button>
            </div>
          </div>
          <div className="cost_bar"></div>
          {!collapsedSections.jobDetails && (
            <div className="cost_grid cost_cols-3">
              <div>
                <label htmlFor="origin">Origin (City, Province)</label>
                <div className="cost_unit">
                  <input
                    id="origin"
                    type="text"
                    placeholder="City, ST, Country or lat,lon"
                    value={form.origin || ""}
                    onChange={(e) => updateForm({ origin: e.target.value })}
                    readOnly
                  />
                </div>
              </div>
              <div>
                <label htmlFor="destination">Destination (City, Province)</label>
                <div className="cost_unit">
                  <input
                    id="destination"
                    type="text"
                    placeholder="City, ST, Country or lat,lon"
                    value={form.destination || ""}
                    onChange={(e) => updateForm({ destination: e.target.value })}
                    readOnly
                  />
                </div>
              </div>
              <div>
                <label htmlFor="moveDate">Move Date</label>
                <div className="cost_unit">
                  <input
                    id="moveDate"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    value={form.moveDate || ""}
                    onChange={(e) => updateForm({ moveDate: e.target.value })}
                    readOnly
                  />
                </div>
              </div>
              <div>
                <label htmlFor="moveSize">Move Size (Bedrooms)</label>
                <div className="cost_unit">
                  <input
                    id="moveSize"
                    type="text"
                    placeholder="Select size…"
                    value={moveSizes.find(opt => opt.value === form.moveSize)?.label || form.moveSize || ""}
                    readOnly
                  />
                </div>
              </div>
            </div>
          )}
        </section>

        <section className="cost_card">
          <div className="cost_row" style={{ justifyContent: "space-between" }}>
            <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Move Details & Profit Range</h2>
            <button
              onClick={() => toggleSection("moveDetails")}
              style={{
                fontSize: "1.2rem",
                cursor: "pointer",
                color: "#333",
                border: "none",
                background: "none",
              }}
            >
              {collapsedSections.moveDetails ? "+" : "−"}
            </button>
          </div>
          <div className="cost_bar"></div>
          {!collapsedSections.moveDetails && (
            <>
              <div className="cost_grid cost_cols-3">
                <ComboField
                  id="startingHub"
                  label="Starting Location (Hub)"
                  options={hubs}
                  onFieldUpdate={(value) => {
                    if (form.stopHub && value) {
                      fetchDistances();
                    }
                  }}
                />
                <ComboField
                  id="stopHub"
                  label="Stop Location (Hub)"
                  options={hubs}
                  onFieldUpdate={(value) => {
                    if (form.startingHub && value) {
                      fetchDistances();
                    }
                  }}
                />
              </div>
              <div className="cost_btns" style={{ marginTop: "8px", position: "relative" }}>
                <button
                  type="button"
                  onClick={fetchDistances}
                  className={isDistanceFetched ? "cost_fetched" : isFetching ? "cost_fetching" : ""}
                >
                  Fetch distances and times (Google Maps)
                  {isFetching && (
                    <span className="spinner" style={{ marginLeft: "8px" }}>↻</span>
                  )}
                </button>
              </div>
              <div className="cost_grid cost_cols-3" style={{ marginTop: "10px" }}>
                <div>
                  <label htmlFor="estWeightLbs">Estimated Weight</label>
                  <div className="cost_unit">
                    <input
                      id="estWeightLbs"
                      type="number"
                      min="0"
                      step="1"
                      placeholder="0"
                      value={form.estWeightLbs || ""}
                      onChange={(e) => {
                        updateForm({ estWeightLbs: e.target.value });
                        autoLoadUnload();
                        calculate();
                      }}
                    />
                    <span>lbs</span>
                  </div>
                </div>
                <div>
                  <label htmlFor="truckSize">Truck Size</label>
                  <div className="cost_unit">
                    <input
                      id="truckSize"
                      type="text"
                      placeholder="e.g., 16 ft / 20 ft / 26 ft"
                      value={form.truckSize || ""}
                      onChange={(e) => updateForm({ truckSize: e.target.value })}
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="numMen">Number of Men</label>
                  <div className="cost_unit">
                    <input
                      id="numMen"
                      type="number"
                      min="1"
                      step="1"
                      placeholder="2"
                      value={form.numMen || ""}
                      onChange={(e) => {
                        updateForm({ numMen: e.target.value });
                        autoLoadUnload();
                        calculate();
                      }}
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="truckCost">Truck Cost</label>
                  <div className="cost_unit">
                    <input
                      id="truckCost"
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="200"
                      value={form.truckCost || ""}
                      onChange={(e) => {
                        updateForm({ truckCost: e.target.value });
                        calculate();
                      }}
                    />
                    <span>$</span>
                  </div>
                  <div className="cost_hint">Enter truck rental or usage cost manually.</div>
                </div>
                <div>
                  <label htmlFor="profitPct">Profit Percentage</label>
                  <div className="cost_unit">
                    <input
                      id="profitPct"
                      type="number"
                      min="0"
                      step="0.1"
                      placeholder="50"
                      value={form.profitPct || ""}
                      onChange={(e) => {
                        updateForm({ profitPct: e.target.value });
                        calculate();
                      }}
                    />
                    <span>%</span>
                  </div>
                  <div className="cost_hint">Applied to (Sub-Total + Lead + Ops)</div>
                </div>
                <div>
                  <label htmlFor="ACVLSplitPct">ACVL Profit Split</label>
                  <div className="cost_unit">
                    <input
                      id="ACVLSplitPct"
                      type="number"
                      min="0"
                      max="100"
                      step="0.1"
                      placeholder="50"
                      value={form.ACVLSplitPct || ""}
                      onChange={(e) => {
                        updateForm({ ACVLSplitPct: e.target.value });
                        calculate();
                      }}
                    />
                    <span>%</span>
                  </div>
                </div>
                <div>
                  <label htmlFor="vendorsplitPct">Vendor Profit Split</label>
                  <div className="cost_unit">
                    <input
                      id="vendorsplitPct"
                      type="number"
                      min="0"
                      max="100"
                      step="0.1"
                      placeholder="50"
                      value={form.vendorsplitPct || ""}
                      readOnly
                    />
                    <span>%</span>
                  </div>
                </div>
              </div>
            </>
          )}
        </section>

        <section className="cost_card">
          <div className="cost_row" style={{ justifyContent: "space-between" }}>
            <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Distance, Cost & Time Calculations</h2>
            <button
              onClick={() => toggleSection("distanceCost")}
              style={{
                fontSize: "1.2rem",
                cursor: "pointer",
                border: "none",
                color: "#333",
                background: "none",
              }}
            >
              {collapsedSections.distanceCost ? "+" : "−"}
            </button>
          </div>
          <div className="cost_bar"></div>
          {!collapsedSections.distanceCost && (
            <div className="cost_grid cost_cols-2">
              <div>
                <label htmlFor="billableKm">Billable Distance</label>
                <div className="cost_unit">
                  <input
                    id="billableKm"
                    type="number"
                    min="0"
                    step="0.1"
                    placeholder="0"
                    value={form.billableKm || ""}
                    onChange={(e) => {
                      updateForm({ billableKm: e.target.value });
                      calculate();
                    }}
                  />
                  <span>km</span>
                </div>
                <div className="cost_hint">Origin → Destination</div>
              </div>
              <div>
                <label htmlFor="nonBillableKm">Non-Billable Distance</label>
                <div className="cost_unit">
                  <input
                    id="nonBillableKm"
                    type="number"
                    min="0"
                    step="0.1"
                    placeholder="0"
                    value={form.nonBillableKm || ""}
                    onChange={(e) => {
                      updateForm({ nonBillableKm: e.target.value });
                      calculate();
                    }}
                  />
                  <span>km</span>
                </div>
                <div className="cost_hint">Start Hub → Origin + Destination → Stop Hub</div>
              </div>
              <div>
                <label htmlFor="billableTimeHrs">Billable Travel Time</label>
                <div className="cost_unit">
                  <input
                    id="billableTimeHrs"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.billableTimeHrs || ""}
                    readOnly
                  />
                  <span>hrs</span>
                </div>
                <div className="cost_hint">Fetched from Google Maps or estimated as Billable Km / 100</div>
              </div>
              <div>
                <label htmlFor="nonBillableTimeHrs">Non-Billable Travel Time</label>
                <div className="cost_unit">
                  <input
                    id="nonBillableTimeHrs"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.nonBillableTimeHrs || ""}
                    readOnly
                  />
                  <span>hrs</span>
                </div>
                <div className="cost_hint">Fetched from Google Maps or estimated as Non-Billable Km / 100</div>
              </div>
              <div>
                <label htmlFor="loadingTimeHrs">Loading Time</label>
                <div className="cost_unit">
                  <input
                    id="loadingTimeHrs"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.loadingTimeHrs || ""}
                    readOnly
                  />
                  <span>hrs</span>
                </div>
                <div className="cost_hint">Capacity: 650 lbs/hour by 2 men (scaled by crew size).</div>
              </div>
              <div>
                <label htmlFor="unloadingTimeHrs">Unloading Time</label>
                <div className="cost_unit">
                  <input
                    id="unloadingTimeHrs"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.unloadingTimeHrs || ""}
                    readOnly
                  />
                  <span>hrs</span>
                </div>
                <div className="cost_hint">Capacity: 850 lbs/hour by 2 men (scaled by crew size).</div>
              </div>
              <div>
                <label htmlFor="driverCost">Driver Cost</label>
                <div className="cost_unit">
                  <input
                    id="driverCost"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.driverCost || ""}
                    readOnly
                  />
                  <span>$</span>
                </div>
                <div className="cost_hint">(Billable + Non-billable + Loading + Unloading) × $20</div>
              </div>
              <div>
                <label htmlFor="helpersCost">Helpers Cost</label>
                <div className="cost_unit">
                  <input
                    id="helpersCost"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.helpersCost || ""}
                    readOnly
                  />
                  <span>$</span>
                </div>
                <div className="cost_hint">Per helper: (Loading + Unloading) × $20 + (Travel × $10) × helpers (men − 1)</div>
              </div>
              <div>
                <label htmlFor="totalLabourCost">Total Labour Cost</label>
                <div className="cost_unit">
                  <input
                    id="totalLabourCost"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.totalLabourCost || ""}
                    readOnly
                  />
                  <span>$</span>
                </div>
              </div>
              <div>
                <label htmlFor="fuelCost">Fuel Cost (auto)</label>
                <div className="cost_unit">
                  <input
                    id="fuelCost"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.fuelCost || ""}
                    readOnly
                  />
                  <span>$</span>
                </div>
                <div className="cost_hint">Fuel = ((Billable Distance + Non-billable Distance) ÷ 3.5) × 1.7</div>
              </div>
              <div>
                <label htmlFor="staircaseFee">Staircase Fee</label>
                <div className="cost_unit">
                  <input
                    id="staircaseFee"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.staircaseFee || ""}
                    readOnly
                  />
                  <span>$</span>
                </div>
                <div className="cost_hint">Staircase Fee</div>
              </div>
              <div>
                <label htmlFor="longWalkCharges">Long Walk Charges</label>
                <div className="cost_unit">
                  <input
                    id="longWalkCharges"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.longWalkCharges || ""}
                    readOnly
                  />
                  <span>$</span>
                </div>
                <div className="cost_hint">Long Walk Charges</div>
              </div>
              <div>
                <label htmlFor="subTotal">Sub-Total</label>
                <div className="cost_unit">
                  <input
                    id="subTotal"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.subTotal || ""}
                    readOnly
                  />
                  <span>$</span>
                </div>
                <div className="cost_hint">Sub-Total = Labour + Truck + Fuel + Stairs + Long Walk</div>
              </div>
              <div>
                <label htmlFor="leadCost">Lead Cost (auto)</label>
                <div className="cost_unit">
                  <input
                    id="leadCost"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.leadCost || ""}
                    readOnly
                  />
                  <span>$</span>
                </div>
                <div className="cost_hint">Lead = Sub-Total × 0.05</div>
              </div>
              <div>
                <label htmlFor="opsExpense">Ops Expense (Chennai) (auto)</label>
                <div className="cost_unit">
                  <input
                    id="opsExpense"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={form.opsExpense || ""}
                    readOnly
                  />
                  <span>$</span>
                </div>
                <div className="cost_hint">Ops = Sub-Total × 0.10</div>
              </div>
            </div>
          )}
        </section>

        <section className="cost_card">
          <div className="cost_row" style={{ justifyContent: "space-between" }}>
            <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Results</h2>
          </div>
          <div className="cost_bar"></div>
          {!collapsedSections.results && (
            <>
              <div className="cost_btns">
                <button onClick={reset}>Reset</button>
              </div>
              <div className="cost_grid cost_cols-2">
                <div className="cost_out">
                  <div className="cost_hint">Estimated Total</div>
                  <div className="cost_tot" id="totalCostDisplay">{fmtMoney(totalCost)}</div>
                  <div className="cost_note">Live formulas based on your rules.</div>
                </div>
                <div className="cost_out">
                  <div className="cost_hint">Breakdown</div>
                  <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>{breakdown}</pre>
                </div>
              </div>
            </>
          )}
        </section>
      </main>
    </div>
  );
};

export default MoveCostCalculator;